import axios from './axios';
import $axios from 'axios';
import config from '../config';
import clubhub from './modules/clubhub';
import elite from './modules/elite';
import injury from './modules/injury';
import staige from './modules/staige';
import player from './modules/player';
import training from './modules/training';
import trainingCamp from './modules/training-camp';
import scoutReport from './modules/scout-report';
// import store from '../store'
export const api = {
  download_attachment: '/download_file', //下载附件
  batch_download_file: '/batch_download_file', //下载伤病附件
};

const server = {
  pushImgOss(data) {
    //上传人脸识别图片
    let instance = $axios.create({});
    return instance.post('/search_face', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  loginEmail(data) {
    //邮箱登录
    return axios('/login_email', {
      method: 'post',
      data,
      paramsType: 'FormData',
      handleTipsBySelf: true, // 自己处理返回值
    });
  },
  resetPassword(data) {
    // 重置密码
    return axios('/reset_password', {
      method: 'post',
      data,
      handleTipsBySelf: true, // 自己处理返回值
      paramsType: 'FormData',
    });
  },
  deleteTacticalBoard(data) {
    return axios('/tactics', {
      //删除战术板
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  getUserRole(params) {
    //查询用户权限---老版本已废弃
    return axios('/user/auth', {
      method: 'get',
      params,
    });
  },
  getOwn_auths(params) {
    // 查询用户权限列表
    return axios('/menu/list', {
      method: 'get',
      params,
    });
  },
  getTeamInfo(params) {
    //获取球队详情
    return axios('/team', {
      method: 'get',
      params,
    });
  },
  getSeasonsList(params) {
    //获取所有赛季
    return axios('/management/seasons', {
      method: 'get',
      params,
    });
  },
  getWeekIndex(params) {
    //获取当前周
    return axios('/current_week_index', {
      method: 'get',
      params,
    });
  },
  getTeamList(params) {
    //获取所有球队列表
    return axios('/teams', {
      method: 'get',
      params,
    });
  },
  // getTeamList(params) {
  //     //获取所有球队列表
  //     return axios('/teams', {
  //         method: 'get',
  //         params,
  //     });
  // },
  getCurrentSeason(params) {
    //获取当前赛季
    return axios('/current_season', {
      method: 'get',
      params,
    });
  },
  getWeekOfYear(params) {
    return axios('/schedule/weekOfYear', {
      // 获取周和年
      method: 'get',
      params,
    });
  },
  getWeeks(params) {
    return axios('/schedule/weeks', {
      // 向后台传周和年获取周视图
      method: 'get',
      params,
    });
  },
  getWorkItemList(params) {
    //获取周视图工作项
    return axios('/schedule/week', {
      method: 'get',
      params,
    });
  },
  addWorkItemTask(data) {
    // 添加日主题
    return axios('/schedule/task', {
      method: 'post',
      data,
    });
  },
  updateWorkItemTask(data) {
    //获取周视图工作项
    return axios('/schedule/task', {
      method: 'put',
      data,
    });
  },
  deleteWorkItemTask(data) {
    // 删除日主题
    return axios('/schedule/task', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  getScheduleMonth(params) {
    //日程-月视图
    return axios('/schedule/month', {
      method: 'get',
      params,
    });
  },
  getScheduleYear(params) {
    //日程-年视图
    return axios('/schedule/year', {
      method: 'get',
      params,
    });
  },
  addScheduleYear(data) {
    //日程-年视图 -- 添加
    return axios('/schedule/year', {
      method: 'post',
      data,
    });
  },
  updateScheduleYear(data) {
    //日程-年视图 -- 修改
    return axios('/schedule/year', {
      method: 'put',
      data,
    });
  },
  // getWeekOfYear(params) {
  //     return axios('/schedule/weekOfYear', {
  //         // 获取周和年
  //         method: 'get',
  //         params,
  //     });
  // },
  // getWeeks(params) {
  //     return axios('/schedule/weeks', {
  //         // 向后台传周和年获取周视图
  //         method: 'get',
  //         params,
  //     });
  // },
  // getWorkItemList(params) {
  //     //获取周视图工作项
  //     return axios('/schedule/week', {
  //         method: 'get',
  //         params,
  //     });
  // },
  // addWorkItemTask(data) {
  //     // 添加日主题
  //     return axios('/schedule/task', {
  //         method: 'post',
  //         data,
  //     });
  // },
  // updateWorkItemTask(data) {
  //     //获取周视图工作项
  //     return axios('/schedule/task', {
  //         method: 'put',
  //         data,
  //     });
  // },
  // deleteWorkItemTask(data) {
  //     // 删除日主题
  //     return axios('/schedule/task', {
  //         method: 'delete',
  //         data,
  //         paramsType: 'FormData',
  //     });
  // },
  // getScheduleMonth(params) {
  //     //日程-月视图
  //     return axios('/schedule/month', {
  //         method: 'get',
  //         params,
  //     });
  // },
  // getScheduleYear(params) {
  //     //日程-年视图
  //     return axios('/schedule/year', {
  //         method: 'get',
  //         params,
  //     });
  // },
  // addScheduleYear(data) {
  //     //日程-年视图 -- 添加
  //     return axios('/schedule/year', {
  //         method: 'post',
  //         data,
  //     });
  // },
  // updateScheduleYear(data) {
  //     //日程-年视图 -- 修改
  //     return axios('/schedule/year', {
  //         method: 'put',
  //         data,
  //     });
  // },
  seasonSyncTeam(data) {
    //不同赛季同步梯队
    return axios('/management/team/sync', {
      method: 'post',
      data,
    });
  },
  getStaffList(params) {
    //获取球队非球员信息--职员
    return axios('/team/staff', {
      method: 'get',
      params,
    });
  },
  // 伤病 - 获取最近伤病治疗记录
  getTreatRecords(params) {
    return axios('/injury/recently', {
      method: 'get',
      params,
    });
  },
  // // 伤病 - 获取最近伤病治疗记录
  // getTreatRecords(params) {
  //     return axios('/injury/recently', {
  //         method: 'get',
  //         params,
  //     });
  // },
  addInJury(data) {
    //添加伤病
    return axios('/injury', {
      method: 'post',
      data,
    });
  },
  injuryHistory(params) {
    //历史伤病
    return axios('/injury/history', {
      method: 'get',
      params,
    });
  },
  injuryDetail(params) {
    //当前所有伤病信息
    return axios('/injury/current', {
      method: 'get',
      params,
    });
  },
  // 查询某一个伤病
  getInjury(params) {
    //当前伤病信息
    return axios('/injury', {
      method: 'get',
      params,
    });
  },
  // injuryHistory(params) {
  //     //历史伤病
  //     return axios('/injury/history', {
  //         method: 'get',
  //         params,
  //     });
  // },
  // injuryDetail(params) {
  //     //当前所有伤病信息
  //     return axios('/injury/current', {
  //         method: 'get',
  //         params,
  //     });
  // },
  // // 查询某一个伤病
  // getInjury(params) {
  //     //当前伤病信息
  //     return axios('/injury', {
  //         method: 'get',
  //         params,
  //     });
  // },
  // 结束某一个伤病
  putInjury(data) {
    //结束或者康复疗程
    return axios('/injury', {
      method: 'put',
      data,
    });
  },
  //获取总伤病图
  putAllInjurySvg(data) {
    //当前伤病信息
    return axios('injury/merge', {
      method: 'put',
      data,
    });
  },
  getPlayersInfoMsg(params) {
    //获取人员基本信息
    return axios('/tenant/user', {
      method: 'get',
      params,
    });
  },
  getFileList(params) {
    //获取附件列表
    return axios('/list_file', {
      method: 'get',
      params,
    });
  },
  tacticalList(params) {
    // 获取战术板列表
    return axios('/tactics/list', {
      //我的战术板
      method: 'get',
      params,
    });
  },
  getLoginUserList(params) {
    return axios('/staff', {
      method: 'get',
      params,
    });
  },
  getDocumentList(params) {
    //文档库列表
    return axios(`${config.resourceUrl}/documents/list`, {
      method: 'get',
      params,
      groupId: true,
    });
  },
  getDocumentSearch(params) {
    //文档库列表--搜索
    return axios(`${config.resourceUrl}/documents/search`, {
      method: 'get',
      params,
      groupId: true,
    });
  },
  // document  -- 获取oss的token    /sts
  getTokenByOss(params) {
    return axios(`${config.resourceUrl}/sts`, {
      method: 'get',
      params,
    });
  },
  createDocumentFile(data) {
    //修改文档库  添加上传文件
    return axios(`${config.resourceUrl}/documents/create_file`, {
      method: 'post',
      data,
    });
  },
  addDocumentFolder(data) {
    //文档库列表--添加一个文件夹
    return axios(`${config.resourceUrl}/documents/create_folder`, {
      method: 'post',
      data,
    });
  },
  updateDocumentFolder(data) {
    //文档库列表--修改文件夹名称
    return axios(`${config.resourceUrl}/documents/rename`, {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  getPlayerVideoNum(params) {
    // 获取球员视频数量
    return axios('/video/player/statistics', {
      method: 'get',
      params,
    });
  },
  // SD 文档库 查树形结构 /documents/folder/list
  getDocumentFolder(params) {
    return axios(`${config.resourceUrl}/documents/folder/list`, {
      method: 'get',
      params,
    });
  },
  // SD 文档库 移动文件夹 /documents/remove
  moveDocumentFolder(data) {
    return axios(`${config.resourceUrl}/documents/remove`, {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },
  getWeather(params) {
    //首页--天气
    return axios('/weather', {
      method: 'get',
      params,
      handleTipsBySelf: true, // 自己处理返回值
    });
  },
  getHome(params) {
    //首页
    return axios('/home', {
      method: 'get',
      params,
    });
  },
  getVisual_auths(params) {
    // 获取所有二级菜单
    return axios('/visual_auths', {
      method: 'get',
      params,
    });
  },
  /* 删除文档库文件 */
  documentsDelete(data) {
    return axios(`${config.resourceUrl}/documents`, {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  uploadFile(data) {
    //通用上传文件
    return axios('/common/upload', {
      method: 'post',
      data: data,
    });
  },
  uploadAttachment(data) {
    // 通用上传附件
    return axios('/upload_file', {
      method: 'post',
      data,
    });
  },
  delAttachment(data) {
    // 删除附件
    return axios('/file', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  careerApi(method, data) {
    // 梯队->职业信息 (post:新增、delete:删除)
    let isDelete = method === 'delete';
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    return axios('/user_career', {
      method,
      data,
      headers: (isDelete && headers) || void 0,
    });
  },
  schoolApi(method, data) {
    // 梯队->教育背景 (post:新增、delete:删除)
    let isDelete = method === 'delete';
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    return axios('/user_school', {
      method,
      data,
      headers: (isDelete && headers) || void 0,
    });
  },
  getExerciseCreater(params, isGroupId = true) {
    //教案创建人筛选项
    return axios(`${config.resourceUrl}/exercise/creator`, {
      method: 'get',
      params,
      groupId: isGroupId,
    });
  },
  getExerciseList(params, isGroupId = true) {
    //练习教案list
    return axios(`${config.resourceUrl}/exercise/list`, {
      method: 'get',
      params,
      groupId: isGroupId,
    });
  },
  getExerciseInfo(params, isGroupId = true) {
    //练习教案详情
    return axios(`${config.resourceUrl}/exercise`, {
      method: 'get',
      params,
      groupId: isGroupId,
    });
  },
  downExercisePiction(params) {
    //练习教案--下载教案图片--文件流
    return axios('/drawingThumbnail/download', {
      method: 'get',
      params,
      handleTipsBySelf: true,
    });
  },
  uploadAnimation(data) {
    //上传动画
    return axios(`${config.resourceUrl}/exercise/video/transcode`, {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  Exercise({ data, params, method }) {
    //创建练习教案
    return axios(`${config.resourceUrl}/exercise`, {
      method,
      headers:
        method === 'delete'
          ? {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
          : void 0,
      data,
      params,
    });
  },
  // 已发布的教案保存为草稿
  draftExercise(params) {
    return axios(`${config.resourceUrl}/exercise/draft`, {
      method: 'put',
      params,
    });
  },

  // 日程 -- 日程详细信息 get获取日程详细信息, post新增日程详细信息, put修改日程详细信息 delete删除
  scheduleWorkItem(params, type, headers) {
    return axios('/schedule/workItem', {
      method: type,
      data: ['get'].includes(type) ? {} : params,
      params: ['get'].includes(type) ? params : {},
      headers,
    });
  },
  // 模板管理 添加工作安排
  scheduleWorkItemTmp(params, type, headers) {
    return axios('/schedule/workItem/tmp', {
      method: type,
      data: ['get'].includes(type) ? {} : params,
      params: ['get'].includes(type) ? params : {},
      headers,
    });
  },
  // 更新日程列表
  putWeekSchedule(data) {
    return axios('/schedule/workItem/list', {
      method: 'put',
      data,
    });
  },
  // 同步日程
  syncSchedule(data) {
    return axios('/schedule/workItem/pull', {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  // 复制日程
  copySchedule(data) {
    return axios('/schedule/workItem/copy', {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  getMaxWeek(params) {
    //今年最大周--用于日程周视图左滑加1
    return axios('/season/max_week', {
      method: 'get',
      params,
    });
  },
  getNoPlayer(params) {
    //梯队教练组数据
    return axios('/team/staff', {
      method: 'get',
      params,
    });
  },
  // gps报告模块 --  gps数据 -- 筛选项请求（跑动距离等）  /catapult/params
  getGpsFilter(params) {
    //梯队球员数据
    return axios('/catapult/params', {
      method: 'get',
      params,
    });
  },
  // gps报告模块 --  同步数据 -- 登录账号  /catapult/login
  getGpsAccount(data) {
    //梯队球员数据
    return axios('/catapult/login', {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  // gps报告模块 --  同步数据 -- 获取活动列表  /catapult/activities
  getGpsActiveList(params) {
    //梯队球员数据
    return axios('/catapult/activities', {
      method: 'get',
      params,
    });
  },
  // gps报告模块 --  同步数据 -- 获取gps数据  /catapult/fetchData
  getGpsData(params) {
    //梯队球员数据
    return axios('/catapult/fetchData', {
      method: 'get',
      params,
    });
  },
  uploadGPSFile(data) {
    //上传gps文件，返回解析json
    return axios('/extract_gps', {
      method: 'post',
      data,
    });
  },
  getGPSList(params) {
    //gps详情列表
    return axios('/gps/list', {
      method: 'get',
      params,
    });
  },
  delectGPS(data) {
    //删除gps详情
    return axios('/gps', {
      method: 'delete',
      data: data,
      paramsType: 'FormData',
    });
  },
  updateGPS(data) {
    //更新gps详情
    return axios('/gps', {
      method: 'put',
      data: data,
    });
  },
  submitGps(data) {
    //提交GPS数据
    return axios('/gps', {
      method: 'post',
      data,
    });
  },
  getGpsReport(params) {
    //GPS报告
    return axios('/gps/report', {
      method: 'get',
      params,
    });
  },
  getACReport(params) {
    //AC报告
    return axios('/gps/ac_report', {
      method: 'get',
      params,
    });
  },
  getAIMReport(params) {
    //AIM报告
    return axios('/gps/aim_report', {
      method: 'get',
      params,
    });
  },
  getGPSAIMReport(params) {
    //强度AIM报告
    return axios('/gps/intensity_report', {
      method: 'get',
      params,
    });
  },
  questionnaire_daily(params) {
    return axios('/questionnaire/daily', {
      // 获取每日问卷
      method: 'GET',
      params,
    });
  },
  getQR(params) {
    //生成二维码
    return axios('/qrcode', {
      method: 'get',
      params,
    });
  },
  updateUser(data, params) {
    //更新用户信息
    return axios('/user', {
      method: 'put',
      data,
      params,
    });
  },
  getEmailReset(params) {
    return axios('/email/reset_password', {
      //发送重置密码邮件
      method: 'get',
      handleTipsBySelf: true, // 自己处理返回值
      params,
    });
  },
  getStatistics(params) {
    return axios('/statistics/schedule', {
      //赛程
      method: 'get',
      params,
    });
  },
  getMatch(params) {
    return axios('/match/overview', {
      //赛程
      method: 'get',
      params,
    });
  },
  getMatchSchedule(params) {
    return axios('/match/schedule', {
      //赛程
      method: 'get',
      params,
    });
  },

  // 获取球员比赛分析
  getMatchAnalyse(params) {
    return axios('/schedule/player/analyse', {
      method: 'get',
      params,
    });
  },
  // 获取球员所有比赛事件
  getAllMatchEvent(params) {
    return axios('/schedule/player/allMachEvent', {
      method: 'get',
      params,
    });
  },
  // 获取赛季数据TOP榜单(射手榜)
  getShooterRank(params) {
    return axios('/rank/shooter', {
      method: 'get',
      params,
    });
  },
  // 获取赛季数据TOP榜单(助攻榜)
  getAssistsRank(params) {
    return axios('/rank/assists', {
      method: 'get',
      params,
    });
  },
  // 获取赛季数据TOP榜单(零封榜)
  getShutoutRank(params) {
    return axios('/rank/shutout', {
      method: 'get',
      params,
    });
  },

  // 比赛事件 -- 比赛事件 post新增比赛详细信息, put修改比赛详细信息 delete删除
  matchEvent(params, type, headers) {
    return axios('/schedule/workItem/match/event', {
      method: type,
      data: type != 'get' ? params : {},
      params: type == 'get' ? params : {},
      headers,
    });
  },
  //添加多条事件 查看事件列表
  matchEvents(params, type, headers) {
    return axios('/schedule/workItem/match/events', {
      method: type,
      data: type != 'get' ? params : {},
      params: type == 'get' ? params : {},
      headers,
    });
  },

  getAddSpeed(data) {
    return axios('/add_speed', {
      //添加Speed数据
      method: 'POST',
      data,
    });
  },
  getSpeedReport(params) {
    return axios('/speed_report', {
      //体测speed数据报告
      method: 'GET',
      params,
    });
  },
  getPlayerSpeedReport(params) {
    return axios('/speed_report_player', {
      // 球员speed数据报告
      method: 'GET',
      params,
    });
  },
  getAddAntro(data) {
    return axios('/add_antro', {
      //添加antro数据
      method: 'POST',
      data,
    });
  },
  getAntroReport(params) {
    return axios('/antro_report', {
      //antro数据报告
      method: 'GET',
      params,
    });
  },
  getAddYoyo(data) {
    return axios('/add_yoyo', {
      //添加yoyo数据
      method: 'POST',
      data,
    });
  },
  getYoyoReport(params) {
    return axios('/yoyo_report', {
      //yoyo数据报告
      method: 'GET',
      params,
    });
  },
  getPlayerYoyoReport(params) {
    return axios('/yoyo_report_player', {
      // 球员yoyo数据报告
      method: 'GET',
      params,
    });
  },
  getAddAgility(data) {
    return axios('/add_agility', {
      //添加Agility数据
      method: 'POST',
      data,
    });
  },
  getAgilityReport(params) {
    return axios('/agility_report', {
      //agility数据报告
      method: 'GET',
      params,
    });
  },
  getPlayerAgilityReport(params) {
    return axios('/agility_report_player', {
      // 球员agility数据报告
      method: 'GET',
      params,
    });
  },
  getAphvReport(params) {
    return axios('/aphv_report', {
      //aphv数据报告
      method: 'GET',
      params,
    });
  },
  // 获取心率分析
  getRateList(params) {
    return axios('/questionnaire/heartRate', {
      method: 'GET',
      params,
    });
  },
  // post 添加RPE数据（批量添加）
  // del 删除RPE数据
  // put 编辑单个RPE数据
  // get 根据id获取单个RPE详情
  rpeApi(params, type) {
    if (type == 'get') {
      return axios('/rpe', {
        method: type,
        params,
      });
    } else if (type == 'post') {
      return axios('/rpe', {
        method: type,
        data: params,
      });
    } else {
      return axios('/rpe', {
        method: type,
        params,
        paramsType: 'FormData',
      });
    }
  },
  //获取梯队rpe数据
  rpeList(params) {
    return axios('/rpe/team', {
      method: 'get',
      params,
    });
  },
  //获取rpe详情
  rpeDetail(params) {
    return axios('/rpe/list', {
      method: 'get',
      params,
    });
  },
  //梯队每日负荷和7天平均负荷
  rpeTeamDailyLoad(params) {
    return axios('/rpe/team/dailyLoad', {
      method: 'get',
      params,
    });
  },
  //当周及前四周每周负荷总和（7天为一周）
  rpeTeamWeekLoad(params) {
    return axios('/rpe/team/weekLoad', {
      method: 'get',
      params,
    });
  },
  //计算ac及负荷相对百分比
  rpeTeamAcLoad(params) {
    return axios('/rpe/team/acLoad', {
      method: 'get',
      params,
    });
  },
  //计算球员28天的RPE及对应的AC
  rpePlayerRolling(params) {
    return axios('/rpe/player/rollingRpe', {
      method: 'get',
      params,
    });
  },
  //计算球员28天Load、RA A:C及EWMA A:C
  rpePlayerRollingLoad(params) {
    return axios('/rpe/player/rollingLoad', {
      method: 'get',
      params,
    });
  },
  //每日问卷调查
  getQuestionnaire(params) {
    return axios('/questionnaire/calculate', {
      method: 'get',
      params,
    });
  },
  // 获取总球员内容
  getQuestionnaireEval(params) {
    return axios('/questionnaire/summary', {
      method: 'get',
      params,
    });
  },
  // 保存总球员内容
  postQuestionnaireEval(data) {
    return axios('/questionnaire/summary', {
      method: 'post',
      data,
    });
  },
  // 修改总球员内容
  putQuestionnaireEval(data) {
    return axios('/questionnaire/summary', {
      method: 'put',
      data,
    });
  },
  // 获取问卷问题
  getQuestionnaireDaily(params) {
    return axios('/questionnaire', {
      method: 'get',
      params,
    });
  },
  // 更新问卷问题
  postQuestionnaireDaily(data) {
    return axios('/questionnaire', {
      method: 'post',
      data,
    });
  },
  // 更新单个问卷问题
  putQuestionnaireItem(data) {
    return axios('/questionnaire', {
      method: 'put',
      data,
    });
  },
  // 删除单个问卷问题
  delQuestionnaireItem(data) {
    return axios('/questionnaire', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  // 获取当天问卷调查列表
  getQuestionnaireDailyList(params) {
    return axios('/questionnaire/list', {
      method: 'get',
      params,
    });
  },
  getVideoList(params) {
    return axios('/video/list', {
      //视频列表
      method: 'GET',
      params,
    });
  },
  getVideo(params) {
    return axios('/video', {
      //视频详情
      method: 'GET',
      params,
    });
  },
  getClipFilters(params) {
    return axios('/video/clip/filters', {
      //视频片段筛选项
      method: 'GET',
      params,
    });
  },
  getClip(params) {
    return axios('/video/clips', {
      //视频片段列表
      method: 'GET',
      params,
    });
  },
  getVideoFilter(params) {
    return axios('/video/player/statistics/filter', {
      // 视频片段筛选
      method: 'GET',
      params,
    });
  },
  saveVideo(data) {
    return axios('/video/save', {
      //保存原视频
      method: 'POST',
      data,
    });
  },
  downClip(params) {
    return axios('/video/clip/download', {
      //视频片段下载
      method: 'GET',
      params,
    });
  },
  getManagementAdd(data, params) {
    return axios('/management/user/add', {
      // 人员管理--添加人员
      method: 'POST',
      data,
      params,
    });
  },
  saveClipVideo(data) {
    return axios('/video/clip', {
      //保存剪辑片段
      method: 'POST',
      data,
    });
  },
  updateClipVideo(data) {
    return axios('/video/clip', {
      //编辑视频片段
      method: 'put',
      data,
    });
  },
  getSelectTeam(data) {
    return axios('/management/season/selectTeam', {
      // 赛季管理--赛季选择梯队
      method: 'POST',
      data,
    });
  },
  addSeason(data) {
    return axios('/management/season', {
      // 添加赛季
      method: 'POST',
      data,
    });
  },
  deleteVideo(data) {
    return axios('/video/delete', {
      //删除原视频
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  deleteClipVideo(data) {
    return axios('/video/clip', {
      //删除视频片段
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  getRoles(params) {
    return axios('/roles', {
      // 人员管理--权限
      method: 'get',
      params,
    });
  },
  getFormationList(params) {
    return axios(`${config.resourceUrl}/formation/list`, {
      // 阵型列表
      method: 'get',
      params,
      groupId: true,
    });
  },
  getFormation(params) {
    return axios(`${config.resourceUrl}/formation`, {
      // 阵型详情
      method: 'get',
      params,
    });
  },
  getFormationCreate(data) {
    return axios(`${config.resourceUrl}/formation`, {
      // 创建阵型
      method: 'POST',
      data,
    });
  },
  gatFormationUpdate(data) {
    // 编辑阵型
    return axios(`${config.resourceUrl}/formation`, {
      method: 'put',
      data,
    });
  },
  gatFormationSearch(params) {
    // 获取阵型
    return axios(`${config.resourceUrl}/formation/search`, {
      method: 'GET',
      params,
    });
  },
  deleteFormationSearch(data) {
    // 删除阵型
    return axios(`${config.resourceUrl}/formation`, {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  gatUserDownloadData(params) {
    // 下载球员资料
    return axios('/user/download_data', {
      // 下载球员资料
      method: 'GET',
      params,
    });
  },
  ajax({ url, method, data, params, otherInfo = {} }) {
    // url 地址，method get 或post data参数
    return axios(url, {
      method: method,
      data: data,
      params,
      headers: otherInfo.headers || void 0,
      handleTipsBySelf: otherInfo.handleTipsBySelf || false, // 自己处理返回值
    });
  },
  capList(params) {
    // url 地址，method get 或post data参数
    return axios('/cap/plan', {
      // cap 获取周期内日程列表
      method: 'GET',
      params,
    });
  },
  capGameTime(params) {
    // url 地址，method get 或post data参数
    return axios('/cap/last/gametime', {
      // cap 上一个训练周期的训练比赛总时长
      method: 'GET',
      params,
    });
  },
  capGenerate(params) {
    // url 地址，method get 或post data参数
    return axios('/cap/plan/generate', {
      // cap 生成训练计划
      method: 'POST',
      params,
    });
  },
  capUpdataGameTime(params) {
    // url 地址，method get 或post data参数
    return axios('/cap/gametime', {
      // cap 生成训练计划
      method: 'GET',
      params,
    });
  },
  getFieldSize(params) {
    return axios('/cap/fieldSize', {
      // cap 生成训练计划
      method: 'GET',
      params,
    });
  },
  getCap_AC(params) {
    return axios('/ac_team_report', {
      // cap -ac数据
      method: 'GET',
      params,
    });
  },
  upDataCap(data, params) {
    return axios('/cap/update/custom', {
      // 查看cap 编辑保存
      method: 'POST',
      data,
      params,
    });
  },
  lastMatchDate(params) {
    return axios('/cap/last/matchday', {
      // 获取上个比赛日
      method: 'GET',
      params,
    });
  },
  matchPlayers(params) {
    return axios('/match/players', {
      // 获取替补球员/助攻
      method: 'GET',
      params,
    });
  },
  // 获取用户的信息
  getUserInfo(params) {
    return axios('/user', {
      method: 'get',
      params,
    });
  },
  // 登录时获取用户的信息
  getUserBaseInfo(params) {
    return axios('/user/base', {
      method: 'get',
      params,
    });
  },
  /*  */
  // 账号密码登录
  loginAccount(data) {
    return axios(`${config.eliteUrl}/guard/identity-to-pass`, {
      method: 'post',
      data,
      handleTipsBySelf: true, // 自己处理返回值
      tenant: false,
    });
  },
  // cfa登录
  loginCFAAccount(params) {
    return axios(`${config.eliteUrl}/guard/cfa-sso/login`, {
      method: 'get',
      params,
      handleTipsBySelf: true, // 自己处理返回值
      tenant: false,
    });
  },
  loginCityEmail(data) {
    //足称办邮箱登录
    return axios(`${config.eliteUrl}/uims/login_email`, {
      method: 'post',
      data,
      paramsType: 'FormData',
      handleTipsBySelf: true, // 自己处理返回值
      tenant: false,
    });
  },
  sendTenantMsg(data) {
    //发送登录短信
    return axios(`${config.eliteUrl}/guard/ticket`, {
      method: 'post',
      data,
      handleTipsBySelf: true, // 自己处理返回值
    });
  },
  resetCityPassword(data) {
    // 重置密码
    return axios(`${config.eliteUrl}/guard/reset-credential`, {
      method: 'post',
      data,
      handleTipsBySelf: true, // 自己处理返回值
    });
  },
  getEmailCityReset(data) {
    return axios(`${config.eliteUrl}/guard/ticket`, {
      //发送重置密码邮件
      method: 'post',
      handleTipsBySelf: true, // 自己处理返回值
      data,
    });
  },
  loginCityPhone(data) {
    //手机号登录
    return axios(`${config.eliteUrl}/guard/ticket-to-pass`, {
      method: 'post',
      data,
      handleTipsBySelf: true,
    });
  },
  // 机构详情
  getTenant(params) {
    return axios(`${config.eliteUrl}/guard/tenant`, {
      method: 'get',
      params,
      tenant: false,
    });
  },
  // 机构列表
  getTenantList(params) {
    return axios(`${config.eliteUrl}/guard/tenant/master/list`, {
      method: 'get',
      params,
      tenant: false,
    });
  },
  // 查询字典
  getDictionary(params) {
    return axios(`${config.CMSAPI}/cms/dictionary`, {
      method: 'get',
      params,
      paramsToken: 'custom-token',
    });
  },
  checkVersion(params) {
    // 检查版本
    return axios(`${config.CMSAPI}/cms/version_history/check_update`, {
      method: 'get',
      params,
    });
  },
  getCurrentNewest(params) {
    // 获取当前最新版本
    return axios(`${config.CMSAPI}/cms/version_history/current`, {
      method: 'get',
      params,
    });
  },
  getRoleList(params) {
    // 获取权限组列表
    return axios(`${config.CMSAPI}/cms/tenant_role_group`, {
      method: 'get',
      params,
    });
  },
  // 查询更新列表
  getVersionHistory(params) {
    return axios(`${config.CMSAPI}/cms/version_histories`, {
      method: 'get',
      params,
    });
  },
  // 软件下载链接
  productDownload(params) {
    return axios(`${config.CMSAPI}/cms/download_url`, {
      method: 'get',
      params,
    });
  },
  // 查最新版本号  // /newest_version
  getVersion(params) {
    return axios('/app/newest_version', {
      method: 'get',
      params,
    });
  },
  //  球探Ts
  //  日程
  getScoutOfficial(params) {
    //查询官方赛事
    return axios('/scout/matches/official', {
      method: 'get',
      params,
    });
  },
  downloadURL(params) {
    // 下载版本
    return axios('/app/download_url', {
      method: 'get',
      params,
    });
  },
  getScheduleWeekList(params) {
    //指定周的赛程/比赛列表
    return axios('/scout/matches/scheduleWeek', {
      method: 'get',
      params,
    });
  },
  getScoutScheduleMonth(params) {
    //获取指定月份的赛事/比赛记录
    return axios('/scout/matches/scheduleMonth', {
      method: 'get',
      params,
    });
  },
  getMatchDetail(params) {
    //获取赛程详情
    return axios('/scout/match/detail', {
      method: 'get',
      params,
    });
  },
  addScoutWorkitem(data) {
    //添加赛程（可以是给官方赛事添加赛程，也可以是普通添加赛程，但是前提还是需要有用户登录）
    return axios('/scout/matches/workitem/add', {
      method: 'POST',
      data: data,
    });
  },
  updateScoutWorkitem(data) {
    //更新赛程/赛事
    return axios('/scout/matches/workitem/update', {
      method: 'POST',
      data: data,
    });
  },
  deleteScoutWorkitem(data, id) {
    //删除日程/删除赛事赛程
    return axios('/scout/matches/workitem/delete?itemId=' + id, {
      method: 'POST',
      data: data,
    });
  },
  getScoutMaxWeek(params) {
    //指定周的赛程/比赛列表
    return axios('/scout/maxWeek', {
      method: 'get',
      params,
    });
  },
  getscoutyears(params) {
    //所有年度赛事信息 //赛事管理
    return axios('/scout/years', {
      method: 'get',
      params,
    });
  },
  getMatchesCount(params) {
    //指定周的赛程总数（日程比赛数）
    return axios('/scout/matches/count', {
      method: 'get',
      params,
    });
  },
  getMatchScores(params) {
    //获取比赛评分列表
    return axios('/scout/match/scores', {
      method: 'get',
      params,
    });
  },
  addMatchScore(data) {
    //添加赛事评分
    return axios('/scout/match/score/add', {
      method: 'POST',
      data: data,
    });
  },
  MatchScoreEdit(data) {
    //更改比赛评分（某个球员的）
    return axios('/scout/match/score/edit', {
      method: 'post',
      data: data,
    });
  },
  deleteScore(data, id, playerId) {
    //删除某个球员的比赛评分
    return axios(
      `/scout/match/score/delete?itemId=${id}&playerId=${playerId}`,
      {
        method: 'POST',
        data: data,
      }
    );
  },
  updateMatch(data) {
    //更新赛事基本信息（中英文）
    return axios('/scout/match/update', {
      method: 'POST',
      data: data,
    });
  },
  addMatch(data) {
    //添加赛事
    return axios('/scout/match/add', {
      method: 'POST',
      data: data,
    });
  },
  addYear(data, yearData) {
    //添加年度
    return axios('/scout/year/add?year=' + yearData, {
      method: 'POST',
      data: data,
    });
  },
  updateYear(data, id, state) {
    //添加年度
    return axios(`/scout/year/update?yearId=${id}&status=${state}`, {
      method: 'POST',
      data: data,
    });
  },
  getMatchesFilter(params) {
    //检索赛事赛程列表
    return axios('/scout/matches/filter', {
      method: 'get',
      params,
    });
  },
  syncMatches(data) {
    //同步赛事（将官方赛事赛程同步到当前登录用户的日程中）
    return axios('/scout/matches/sync', {
      method: 'POST',
      data: data,
    });
  },
  //日程结束

  // ts - 球员追踪 -- 关注球员列表请求函数  --/track/list
  getfollowPlayerList(params) {
    return axios('/track/list', {
      method: 'get',
      params,
    });
  },
  // ts - 球员追踪  -- 删除关注球员列表中的球员  -- /track/delete
  delfollowPlayer(data) {
    return axios('/track/delete', {
      method: 'post',
      data: data,
    });
  },
  // ts - 球员追踪  -- 添加追踪球员弹窗的所有球员列表 /track/player/notfocus
  getNotfocusPlayers(params) {
    return axios('/track/player/notfocus', {
      method: 'get',
      params,
    });
  },
  // ts - 球员追踪  -- 添加追踪的球员  --/track/add
  addfollowPlayer(data) {
    return axios('/track/add', {
      method: 'post',
      data: data,
    });
  },
  // ts - 球员追踪 -- 添加球员到讨论组   /track/discussion/add
  adddiscussionPlayer(data) {
    return axios('/track/discussion/add', {
      method: 'post',
      data: data,
    });
  },
  //  ts - 球员追踪 -- 获取讨论组列表    -- /track/discussion
  getDiscusslist(params) {
    return axios('/track/discussion', {
      method: 'get',
      params,
    });
  },
  // ts - 球员追踪 -- 讨论组列表- 操作建议接口   ---/track/discussion/update
  updateDiscusslist(data) {
    return axios('/track/discussion/update', {
      method: 'post',
      data: data,
    });
  },
  // ts - 球员追踪 -- 讨论组列表- 删除讨论组球员   /track/discussion/delete
  delDiscussionPlayer(data) {
    return axios('/track/discussion/delete', {
      method: 'post',
      data: data,
    });
  },

  // ts -- 球员管理 -- 新增球员     /management/player/add
  addPlayer(data) {
    return axios('/management/player/add', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 球员管理 -- 新增球员 --上传视频  -- /basic/uploadFile
  uploadVideo(data) {
    return axios('/basic/uploadFile', {
      method: 'post',
      data: data,
    });
  },

  // ts -- 球员管理  -- 待处理列表数据 / 全部球员列表数  --  /basic/player/list
  // 如果传 Unprocessed 则显示待处理球员列表,不传则为全部球员
  getAllPlayerList(params) {
    return axios('/basic/player/list', {
      method: 'get',
      params,
    });
  },
  // ts -- 球员管理  -- 球员编辑保存   --  /basic/player/update
  savePlayerInfo(data) {
    return axios('/basic/player/update', {
      method: 'post',
      data: data,
    });
  },

  // ts  -- 球员管理  -- 试训球员列表   -- /trial/player/list
  getTrainingList(params) {
    return axios('/trial/player/list', {
      method: 'get',
      params,
    });
  },
  // ts  -- 球员管理  -- 试训球员  --删除球员   /trial/end
  delTrainingPlayer(data) {
    return axios('/trial/end', {
      method: 'post',
      data: data,
    });
  },
  // ts  -- 球员管理  -- 试训球员  --添加球员时球员列表  /trial/optional/players
  getAddPlayers(params) {
    return axios('/trial/optional/players', {
      method: 'get',
      params,
    });
  },
  //   ts  -- 球员管理  -- 试训球员  --新增试训球员    /trial/add
  addTryTrainPlayer(data) {
    return axios('/trial/add', {
      method: 'post',
      data: data,
    });
  },
  // ts  -- 球员管理  -- 组队球员列表   /teamBuild/list
  getOrganizeTeamList(params) {
    return axios('/teamBuild/list', {
      method: 'get',
      params,
    });
  },
  // ts  -- 球员管理  -- 组队球员 -- 删除梯队   --/ts/player/team/delete
  delTeamInfo(data) {
    return axios('/teamBuild/delete', {
      method: 'post',
      data: data,
    });
  },
  //  ts  -- 球员管理  -- 组队页面 -- 组建梯队  /teamBuild/add
  addTrainalTeam(data) {
    return axios('/teamBuild/add', {
      method: 'post',
      data: data,
    });
  },
  // ts  -- 球员管理  -- 组队页面 添加球员  /teamBuild/selectUser
  addTrainalTeamPlayers(data) {
    return axios('/teamBuild/selectUser', {
      method: 'post',
      data: data,
    });
  },
  //  ts  -- 球员管理  -- 组队弹窗页面 -- 未成队的梯队列表  /ts/player/team/all
  getPendingTeam(params) {
    return axios('/ts/player/team/all', {
      method: 'get',
      params,
    });
  },
  //  ts  -- 球员管理  -- 组队球员 -- 修改梯队名称  -- /teamBuild/update
  updateTeamInfo(data) {
    return axios('/teamBuild/update', {
      method: 'post',
      data: data,
    });
  },
  // ts  -- 球员管理  待处理列表数据/全部球员列表数据  删除球员 -- /basic/player/delete
  delplayer(data) {
    return axios('/basic/player/delete', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 球员管理   -- 球员详情   --  /basic/player/detail
  getPlayerInfo(params) {
    return axios('/basic/player/detail', {
      method: 'get',
      params,
    });
  },
  // ts -- 球员管理 -- 球员详情   --基础信息 --保存为新球员  --  /basic/player/saveAsNew
  saveNewPlayer(data) {
    return axios('/basic/player/saveAsNew', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 球员管理 -- 球员详情--基础信息--保存为现有球员  /basic/player/saveAsExist
  mergePlayer(data) {
    return axios('/basic/player/saveAsExist', {
      method: 'post',
      data: data,
    });
  },
  //  ts -- 球员管理 -- 球员详情--球员评分-=时间  -   /playerScore/filter
  getScoreTime(params) {
    return axios('/playerScore/filter', {
      method: 'get',
      params,
    });
  },
  // ts -- 球员管理 -- 球员详情--球员评分右侧-分数表格    /playerScore/data
  getScoreTable(params) {
    return axios('/playerScore/data', {
      method: 'get',
      params,
    });
  },
  //ts -- 球员管理 -- 球员详情 -- 球探评分 /basic/score/add
  addScoutScore(data) {
    return axios('/basic/score/add', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 球员管理 -- 球员详情--获取视频列表   /basic/video/list
  getMatchVideoList(params) {
    return axios('/basic/video/list', {
      method: 'get',
      params,
    });
  },
  // ts -- 球员管理 -- 球员详情--获取视频详情   /ts/palyer/video/bizList?bizId=1213321
  getVideoDetail(params) {
    return axios('/ts/palyer/video/bizList', {
      method: 'get',
      params,
    });
  },
  // ts -- 球员管理 -- 球员详情--删除视频   /basic/video/delete
  delVideoInfo(data) {
    return axios('/basic/video/delete', {
      method: 'post',
      data: data,
    });
  },
  //  ts -- 球员管理 -- 球员详情--集训得分 - 右侧表格数据  /assemble/player/data
  getTrainalScoreTable(params) {
    return axios('/assemble/player/data', {
      method: 'get',
      params,
    });
  },
  //  ts -- 球员管理 -- 球员详情--集训得分 - 左侧时间轴数据  /assemble/player/filter
  getTrainalScoreTime(params) {
    return axios('/assemble/player/filter', {
      method: 'get',
      params,
    });
  },
  // ts -- 球员管理 -- 球员详情--试训记录 - 右侧表格数据  /trial/player/data
  getTrainalrecordTable(params) {
    return axios('/trial/player/data', {
      method: 'get',
      params,
    });
  },
  // ts -- 球员管理 -- 球员详情--试训记录 - 左侧时间轴数据 /trial/player/filter
  getTrainalrecordTime(params) {
    return axios('/trial/player/filter', {
      method: 'get',
      params,
    });
  },
  //  ts -- 球员管理 获取球员列表  -- /management/player/list
  /***
   * 1. 合并球员时：列表数据
   * 2. 组队弹窗，球员列表数据
   * **/
  // ts -- 组队管理 获取队伍中的球员列表  --/ts/player/team/players
  getPlayerForTeam(params) {
    return axios('/ts/player/team/players', {
      method: 'get',
      params,
    });
  },
  //  ts -- 成队  /teamBuild/establish
  createTeam(data) {
    return axios('/teamBuild/establish', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 成队  球员列表接口  /teamBuild/player/list
  createTeamPlayerList(params) {
    return axios('/teamBuild/player/list', {
      method: 'get',
      params,
    });
  },
  // ts -- 集训 -- 梯队下的球员列表  -- /assemble/player/list
  getplayersByTeam(params) {
    return axios('/assemble/player/list', {
      method: 'get',
      params,
    });
  },
  // ts -- 集训 -- 集训记录  -- /assemble/list
  getTrainRecord(params) {
    return axios('/assemble/list', {
      method: 'get',
      params,
    });
  },
  // ts -- 集训 -- 创建集训信息    /assemble/add
  addTrainInfo(data) {
    return axios('/assemble/add', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 集训 -- 更新集训信息    /assemble/update
  uploadTrainInfo(data) {
    return axios('/assemble/update', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 集训 -- 集训信息详情    /assemble/detail
  viewTrainInfo(params) {
    return axios('/assemble/detail', {
      method: 'get',
      params,
    });
  },
  //  ts -- 集训 -- 集训评分 /assemble/report/add
  sendTrainScore(data) {
    return axios('/assemble/report/add', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 集训 -- 删除集训信息      /assemble/delete
  delTrainInfo(data) {
    return axios('/assemble/delete', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 集训 -- 教练组 --教练下拉数据   /management/staff/list --- 同球探数据
  getCoachList(params) {
    return axios('/management/staff/list', {
      method: 'get',
      params,
    });
  },
  // ts -- 评分 -- ISR守门员评分  /ts/players/score/isr/gk
  isrGkScore(data) {
    return axios('/ts/players/score/isr/gk', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 评分 -- ISR球员评分  /ts/players/score/isr
  isrPlayerScore(data) {
    return axios('/ts/players/score/isr', {
      method: 'post',
      data: data,
    });
  },
  // ts -- 评分 -- ESR球员 / 守门员评分    /ts/players/score/esr
  esrScore(data) {
    return axios('/ts/players/score/esr', {
      method: 'post',
      data: data,
    });
  },
  /***
   *  ts  获取ts - 评分二维码接口
   *  /player/management/qrcode
   *  1. h5 球员创建
   * ·2. h5 球探评分
   *  3. h5 试训评分
   *  4. h5 集训评分
   * **/
  getScoreQrcode(params) {
    return axios('/player/management/qrcode', {
      method: 'get',
      params,
      handleTipsBySelf: true,
    });
  },
  // ts - 试训  -- 获取当前球员试训信息   /trial/latest
  getplayerTrainInfo(params) {
    return axios('/trial/latest', {
      method: 'get',
      params,
    });
  },
  // 查询权限范围（即可见数据的下级列表）
  userAuth(params) {
    return axios('/user_auth', {
      method: 'get',
      params,
    });
  },
  // 消息模块  -- 获取消息列表   /message/list
  getMessageList(params) {
    return axios('/message/list', {
      method: 'get',
      params,
    });
  },
  // 消息模块  -- 更新消息状态  /message/update
  updateMessageStatus(data) {
    return axios('/message/update', {
      method: 'post',
      data: data,
    });
  },
  //  // 消息模块  -- 消息全部维度事件   /message/notRead
  getMessageNumber(params) {
    return axios('/message/notRead', {
      method: 'get',
      params,
    });
  },
  // 消息模块  -- 消息类型tab   --/product/list
  getMessageTab(params) {
    return axios('/product/list', {
      method: 'get',
      params,
    });
  },
  // 消息模块  -- 删除消息  /message/delete
  delMessage(data) {
    return axios('/message/delete', {
      method: 'post',
      data: data,
    });
  },
  // 查询用户组织
  userOrganizations(params) {
    return axios('/user/organizations', {
      method: 'get',
      params,
    });
  },

  // 获取上传文件需要加上id的类型
  fileTypes(params) {
    return axios('/file/types', {
      method: 'get',
      params,
    });
  },

  /* 体测报告-脉搏 */
  getPulse(params) {
    return axios('/pulse_report', {
      method: 'get',
      params,
    });
  },
  getInjuryReport(params) {
    return axios('/injury/team_report', {
      method: 'get',
      params,
    });
  },
  // 查看所有的快捷方式
  getShortcuts(params) {
    return axios('/menu/shortcuts', {
      method: 'get',
      params,
    });
  },

  // 查看用户配置，包括用户的快捷方式等...
  getUserConfig(params) {
    return axios('/user/config', {
      method: 'get',
      params,
    });
  },

  // 编辑用户配置
  setUserConfig(data) {
    return axios('/user/config', {
      method: 'post',
      data: data,
    });
  },
  // 添加、编辑职务
  addJob(data, method) {
    if (method === 'post') {
      return axios('/job/', {
        method: 'post',
        data,
      });
    }
    if (method === 'put') {
      return axios('/job/', {
        method: 'put',
        data,
      });
    }
  },
  // 删除职务
  removeJob(data) {
    return axios('/job', {
      method: 'delete',
      paramsType: 'FormData',
      data,
    });
  },
  // 职务排序
  reorderJob(params) {
    return axios('/job/reorder', {
      method: 'put',
      params,
    });
  },
  /**
   * 人员管理
   */
  // 球员列表
  getPlayer(params) {
    return axios('/management/user/player/list', {
      method: 'get',
      params,
    });
  },
  // 职员列表
  getStaff(params) {
    return axios('/management/user/staff/list', {
      method: 'get',
      params,
    });
  },
  // 职员列表
  addUser(data, method) {
    if (method === 'post') {
      return axios('/management/user', {
        method: 'post',
        data,
      });
    }
    if (method === 'put') {
      return axios('/management/user', {
        method: 'put',
        data,
      });
    }
  },
  // 职员列表
  removeUser(params) {
    return axios('/management/user', {
      method: 'delete',
      params,
    });
  },
  /**
   * 梯队管理
   */
  // 梯队列表
  getTeamAll(params) {
    return axios('/management/team/all', {
      method: 'get',
      params,
    });
  },
  // 移动梯队位置
  reorderTeam(params) {
    return axios('/management/team/reorder', {
      method: 'put',
      params,
    });
  },
  // 新增/编辑梯队
  addTeam(data, method) {
    if (method === 'post') {
      return axios('/management/team', {
        method: 'post',
        data,
      });
    }
    if (method === 'put') {
      return axios('/management/team', {
        method: 'put',
        data,
      });
    }
  },
  // 删除梯队
  removeTeam(params) {
    return axios('/management/team', {
      method: 'delete',
      params,
    });
  },
  // 梯队管理 删除人员
  removeTeamUser(data) {
    return axios('/management/team/remove_user', {
      method: 'post',
      data,
    });
  },
  // 梯队选择人员/编辑人员
  selectUser({ data, params }) {
    return axios('/management/team/selectUser', {
      method: 'post',
      data,
      params,
    });
  },
  // 归档列表
  getArchiveList(params) {
    return axios('/team/archive/list', {
      method: 'get',
      params,
    });
  },
  // 归档梯队添加
  teamArchive(data) {
    return axios('/team/archive/', {
      method: 'post',
      data,
    });
  },
  // 归档梯队删除
  removeArchive(params) {
    return axios('/team/archive/', {
      method: 'delete',
      params,
    });
  },
  // 归档梯队详情
  teamArchiveDetail(params) {
    return axios('/team/archive/', {
      method: 'get',
      params,
    });
  },
  // 梯队--球员
  getTeamPlayers(params) {
    return axios('/management/team/player/list', {
      method: 'get',
      params,
    });
  },
  // 梯队--添加球员列表
  getAddPlayerList(params) {
    return axios('/management/team/add_user/player_list', {
      method: 'get',
      params,
    });
  },
  // 梯队--职员
  getTeamStaffs(params) {
    return axios('/management/team/staff/list', {
      method: 'get',
      params,
    });
  },
  // 梯队--添加职员列表
  getAddStaffList(params) {
    return axios('/management/team/add_user/staff_list', {
      method: 'get',
      params,
    });
  },
  // 添加球员到梯队
  addTeamUser(data) {
    return axios('/management/team/add_user', {
      method: 'post',
      data,
    });
  },
  // 编辑球员梯队状态
  editTeamUser(data) {
    return axios('/management/team/player_status', {
      method: 'put',
      data,
    });
  },
  // 梯队标签列表
  getTeamTagList(params) {
    return axios('/management/team/tag/list', {
      method: 'get',
      params,
    });
  },
  // 查询球员标签
  getTeamTagDetails(params) {
    return axios('/management/tag/list/player', {
      method: 'get',
      params,
    });
  },
  // 给球员添加标签
  addTeamPlayerTag(params) {
    return axios('/management/tag/player', {
      method: 'put',
      data: params.data,
      params: params.params,
    });
  },

  // 查询人员信息，支持一次查询多个
  staffUsers(params) {
    return axios('/users', {
      method: 'get',
      params,
    });
  },

  // 增改赛季
  season({ data, method }) {
    return axios('/management/season', {
      method,
      data,
    });
  },

  // 检查文件是否存在
  getDownloadFile(params) {
    return axios('/common/check', {
      method: 'get',
      params,
      handleTipsBySelf: true,
    });
  },
  // 检查短片是否存在
  getDownloadClip(params) {
    return axios('/video/clip/check', {
      method: 'get',
      params,
      handleTipsBySelf: true,
    });
  },
  // 标签===========================START
  // 标签列表 标签管理 type:exercise/workItem
  getTagList(params) {
    return axios('/tag/list', {
      method: 'get',
      params,
      headers: void 0,
      groupId: true,
    });
  },
  // 标签 增（post） 删（delete） 改（put） 标签管理
  getTags(data, method) {
    return axios('/tag', {
      method,
      headers:
        method === 'delete'
          ? {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
          : void 0,
      data: data,
    });
  },
  // 教案标签 筛选
  getExerciseTags(params, isGroupId = true) {
    return axios(`${config.resourceUrl}/exercise/tags`, {
      method: 'get',
      params,
      groupId: isGroupId,
    });
  },
  // 比赛标签 筛选
  getScheduleTags(params) {
    return axios('/schedule/tags', {
      method: 'get',
      params,
    });
  },
  // 标签===========================END

  // 复制教案为副本
  exerciseCopy(data) {
    return axios(`${config.resourceUrl}/exercise/copy`, {
      method: 'post',
      data: data,
      paramsType: 'FormData',
    });
  },

  // 发布教案
  exercisePublish(params) {
    return axios(`${config.resourceUrl}/exercise/finalized`, {
      method: 'post',
      params,
    });
  },

  //    sr
  // sr 首页 - 课程表
  getCurriculumWeek(params) {
    return axios('/curriculum/week', {
      method: 'get',
      params,
    });
  },
  // sr 首页 - 添加单科课程
  addCurriculum(data) {
    return axios('/curriculum', {
      method: 'post',
      data,
    });
  },
  // sr 模板 - 添加模板
  addCurriculumTemplate(data) {
    return axios('/curriculum/template', {
      method: 'post',
      data,
    });
  },
  // sr 模板 - 更新模板
  updateCurriculumTemplate(data) {
    return axios('/curriculum/template', {
      method: 'put',
      data,
    });
  },
  // sr 模板 - 获取模板详情
  getCurriculumTemplateDetail(params) {
    return axios('/curriculum/template', {
      method: 'get',
      params,
    });
  },
  // sr 模板 - 删除模板
  delCurriculumTemplate(data) {
    return axios('/curriculum/template', {
      method: 'DELETE',
      data,
      paramsType: 'FormData',
    });
  },
  // sr 模板 - 导入模板
  uploadCurriculumTemplate(data) {
    return axios('/curriculum/template/sync', {
      method: 'post',
      data,
    });
  },
  //sr 模板列表
  getCurriculumTemplateList(params) {
    return axios('/curriculum/template/list', {
      method: 'get',
      params,
    });
  },
  //sr 课程详情
  getCurriculumDetails(params) {
    return axios('/curriculum', {
      method: 'get',
      params,
    });
  },
  //sr 课程编辑
  putCurriculum(data) {
    return axios('/curriculum', {
      method: 'put',
      data,
    });
  },
  //sr 课程删除
  getCurriculumDelete(data) {
    return axios('/curriculum', {
      method: 'delete',
      data: data,
      paramsType: 'FormData',
    });
  },
  //sr 课程成绩单
  getCurriculumEdu(params) {
    return axios('/curriculum/edu', {
      method: 'get',
      params,
    });
  },

  // 成绩单列表
  getEduList(params, type, headers) {
    return axios('/edu/list', {
      method: type,
      data: type != 'get' ? params : {},
      params: type == 'get' ? params : {},
      headers,
    });
  },
  //
  //post添加成绩单  put修改成绩单   get成绩单详情
  edu(data, type, headers) {
    return axios('/edu', {
      method: type,
      data: type != 'get' ? data : {},
      params: type == 'get' ? data : {},
      headers,
    });
  },
  //新增成绩详情 -- 给某些球员录入成绩
  eduDetail(data, type, headers, params) {
    return axios('/edu/detail', {
      method: type,
      data: type != 'get' ? data : {},
      params: params ? params : type == 'get' ? data : {},
      headers,
    });
  },
  //    归档
  eduArchive(params, type, headers) {
    return axios('/edu/archive', {
      method: type,
      data: type != 'get' ? params : {},
      params: type == 'get' ? params : {},
      headers,
    });
  },
  getEduArchives(params, type, headers) {
    return axios('/edu/archives', {
      method: type,
      data: type != 'get' ? params : {},
      params: type == 'get' ? params : {},
      headers,
    });
  },

  // sr - 查询球员成绩详情
  playerScore(type, params) {
    return axios('/edu/details', {
      method: type,
      data: type != 'get' ? params : {},
      params: type == 'get' ? params : {},
    });
  },

  // sr - 总成绩列表
  getTotalScoreList(params) {
    return axios('/total_score_list', {
      method: 'get',
      params,
    });
  },

  // sr - 新增总成绩名称
  postTotalScore(data) {
    return axios('/total_score', {
      method: 'post',
      data,
    });
  },

  // sr - 修改总成绩名称
  putTotalScore(data) {
    return axios('/total_score', {
      method: 'put',
      data,
    });
  },

  // sr - 删除总成绩
  delTotalScore(data, headers) {
    return axios('/total_score', {
      method: 'delete',
      headers,
      data,
    });
  },

  // sr - 获取总成绩详情
  getTotalScoreDetail(params) {
    return axios('/total_score', {
      method: 'get',
      params,
    });
  },

  // sr - 新增总成绩详情
  postTotalScoreDetail(data) {
    return axios('/total_score_detail', {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },

  // sr - 新增总成绩详情
  delTotalScoreDetail(data) {
    return axios('/total_score_detail', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },

  // 未被分配到当前梯队的职员
  staffNotSelect(params) {
    return axios('/staff/notSelect', {
      method: 'get',
      params,
    });
  },

  // 未被分配到当前梯队的球员
  playerNotSelect(params) {
    return axios('/player/notSelect', {
      method: 'get',
      params,
    });
  },

  // TU  阵容  --新增 / 编辑  /lineup
  submitlineup(data) {
    return axios('/lineup', {
      method: 'post',
      data,
    });
  },
  // TU  阵容  --获取阵容 / 编辑  /lineup
  getlineupList(params) {
    return axios('/lineup', {
      method: 'get',
      params,
    });
  },

  // PI -- 球员评估
  // 评估模版
  evalTemplate(method, data) {
    if (method == 'get') {
      return axios('/evaluation_template', {
        method,
        params: data,
      });
    }
    if (method == 'delete') {
      return axios('/evaluation_template', {
        method: 'delete',
        data: data,
        paramsType: 'FormData',
      });
    }
    return axios('/evaluation_template', {
      method,
      data,
    });
  },

  // 评估模版详情
  evalTemplateItem(method, data) {
    if (method == 'get') {
      return axios('/evaluation_template_item', {
        method,
        params: data,
      });
    }
    if (method == 'delete') {
      return axios('/evaluation_template_item', {
        method: 'delete',
        data: data,
        paramsType: 'FormData',
      });
    }
    return axios('/evaluation_template_item', {
      method,
      data,
    });
  },

  // 评估内容
  evalData(method, data) {
    if (method == 'get') {
      return axios('/evaluation_data', {
        method,
        params: data,
      });
    }
    if (method == 'delete') {
      return axios('/evaluation_data', {
        method: 'delete',
        data: data,
        paramsType: 'FormData',
      });
    }
    return axios('/evaluation_data', {
      method,
      data,
    });
  },

  // 个人评估内容
  evaluation(method, data) {
    if (method == 'get') {
      return axios('/evaluation', {
        method,
        params: data,
      });
    }
    if (method == 'delete') {
      return axios('/evaluation', {
        method: 'delete',
        data: data,
        paramsType: 'FormData',
      });
    }
    return axios('/evaluation', {
      method,
      data,
    });
  },
  // 评估模板列表
  getEvalTemplate(params) {
    return axios(`${config.CMSAPI}/cms/tenant_evaluation_template/list`, {
      method: 'get',
      params,
    });
  },

  // 评估模板详情
  getEvalTemplateDetail(params) {
    return axios(`${config.CMSAPI}/cms/tenant_evaluation_template`, {
      method: 'get',
      params,
    });
  },

  // 查询单个评估
  getEvaluation(params) {
    return axios(`/evaluation`, {
      method: 'get',
      params,
    });
  },

  // 操作球员教练员评估(新增、修改)
  submitUserEval(params) {
    if (params.method === 'delete') {
      params.headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };
    }
    return axios('/evaluation', {
      ...params,
    });
  },

  // 操作球员教练员评估内容(新增、修改)
  submitUserEvalData(params) {
    if (params.method === 'delete') {
      params.headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };
    }
    return axios('/evaluation_data', {
      ...params,
    });
  },

  // 评估内容列表
  getUserEvalDataList(params) {
    return axios('/evaluation_data/list', {
      method: 'get',
      params,
    });
  },
  // 周运营 - 获取运营列表
  getLogsList(params) {
    return axios('/operation_log_list', {
      method: 'get',
      params,
    });
  },
  // 周运营 - 新增运营日志
  addLogsDetail(data) {
    return axios('/operation_log', {
      method: 'post',
      data,
    });
  },
  // 周运营 - 删除运营日志
  delLogsDetail(data) {
    return axios('/operation_log', {
      method: 'DELETE',
      data,
      paramsType: 'FormData',
    });
  },
  // 周运营 - 更新运营日志
  updateLogsDetail(data) {
    return axios('/operation_log', {
      method: 'PUT',
      data,
    });
  },
  // 周运营 - 运营日志详情
  getLogsDetail(params) {
    return axios('/operation_log', {
      method: 'get',
      params,
    });
  },
  // 周运营 - 新增运营日志评价
  addLogsEval(data) {
    return axios('/operation_log_evaluation', {
      method: 'post',
      data,
    });
  },
  // 周运营 - 更新运营日志评价
  updateLogsEval(data) {
    return axios('/operation_log_evaluation', {
      method: 'put',
      data,
    });
  },
  // 周运营 - 删除运营日志评价
  delLogsEval(data) {
    return axios('/operation_log_evaluation', {
      method: 'DELETE',
      data,
      paramsType: 'FormData',
    });
  },
  // 查询球员在指定赛季的所有评估列表
  getUserEvalList(params) {
    return axios('/evaluation/list', {
      method: 'get',
      params,
    });
  },

  // 球员评估对比
  getUserEvalDiff(params) {
    return axios('/evaluation_diff', {
      method: 'get',
      params,
    });
  },

  /**
    getPlayersReportAll(params) {
        //获取所有数据--柱状图显示
        return axios('/evaluation_report/all', {
            method: 'get',
            params,
        });
    },
    getPlayersReportData(params) {
        //获取评估详细数据
        return axios('/evaluation_report', {
            method: 'get',
            params,
        });
    },
    // PI 编辑职员评估
    updateStaffQuestion(data) {
        return axios('/evaluation_report/staff', {
            method: 'put',
            data: data,
            // headers: {
            //     'Content-Type': 'application/x-www-form-urlencoded',
            // }
        });
    },
    // PI 删除评估
    delStaffQuestion(params) {
        return axios('/evaluation_report', {
            method: 'delete',
            params,
        });
    },
    getPlayersReportScore(params) {
        //获取评估项对应的比较分数
        return axios('/evaluation_report/diff', {
            method: 'get',
            params,
        });
    },
     **/

  getPlayersQuestion(params) {
    //获取评估项对应的比较分数
    return axios('/evaluation/question', {
      method: 'get',
      params,
    });
  },

  // PI  -- 教练组评估  -- 获取评估题目  /evaluation/staff/question
  getStaffQuestion(params) {
    return axios('/evaluation/staff/question', {
      method: 'get',
      params,
    });
  },

  //  PI  -- 教练组评估  -- 提交评估题目答案  /evaluation_report/staff/submit
  submitStaffQuestion(data) {
    return axios('/evaluation_report/staff/submit', {
      method: 'post',
      data: data,
    });
  },

  //  PI  -- 教练组评估  --  获取最新一次报告数据   /evaluation_report/latest?seasonId=&userId=
  getLastEvaluationReport(params) {
    return axios('/evaluation_report/latest', {
      method: 'get',
      params,
    });
  },

  // 产品更新内容提示信息  /product_intro
  getProductIntro(params) {
    return axios('/product_intro', {
      method: 'get',
      params,
    });
  },
  // 获取本次更新产品详情  /product/current_update?version=
  getProductIntroLast(params) {
    return axios('/product/current_update', {
      method: 'get',
      params,
    });
  },

  //    总结
  //    总结信息获取
  summaryList(params) {
    return axios('/item/summary/list', {
      method: 'get',
      params,
    });
  },
  //    总结信息添加
  addSummary(data) {
    return axios('/item/summary', {
      method: 'post',
      data: data,
    });
  },
  //    总结信息更新
  updateSummary(data) {
    return axios('/item/summary', {
      method: 'put',
      data: data,
    });
  },
  delSummary(data) {
    //删除gps详情
    return axios('/item/summary', {
      method: 'delete',
      data: data,
      paramsType: 'FormData',
    });
  },

  // 更改邮箱
  changeEmail(data) {
    return axios('/management/change/email', {
      method: 'put',
      data: data,
      paramsType: 'FormData',
    });
  },

  // 更改手机号
  changePhone(data) {
    return axios('/management/change/phone', {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },

  // 获取验证码
  getChangeCode(params) {
    return axios('/management/change/code', {
      method: 'get',
      params,
    });
  },

  // 比赛球员数据
  getVideoWorkItemPlayers(params) {
    return axios('/schedule/workItem/players', {
      method: 'get',
      params,
    });
  },

  // 获取比赛日程的标签
  getScheduleWorkItemTag(params) {
    return axios('/schedule/workItem/tag', {
      method: 'get',
      params,
    });
  },

  // 添加比赛日程的标签
  addScheduleWorkItemTag(params, data) {
    return axios('/schedule/workItem/tag', {
      method: 'post',
      params,
      data,
    });
  },
  //    梯队周总结
  // 获取梯队周报告问题列表
  getReportTeamQuestion(params) {
    return axios('/report/team/question', {
      method: 'get',
      params,
    });
  },
  // 获取梯队报告年列表或按月分组
  getReportTeamYear(params) {
    return axios('/report/team/year', {
      method: 'get',
      params,
    });
  },
  // 获取梯队报告
  getReportTeam(params) {
    return axios('/report/team', {
      method: 'get',
      params,
    });
  },
  // 添加梯队周报告
  addReportTeam(data) {
    return axios('/report/team', {
      method: 'post',
      data,
    });
  },
  // 添加梯队周报告
  upReportTeam(data) {
    return axios('/report/team', {
      method: 'put',
      data,
    });
  },
  // 删除梯队周报告
  delReportTeam(params) {
    return axios('/report/team', {
      method: 'delete',
      params,
      paramsType: 'FormData',
    });
  },

  //    足协周总结
  // 获取足协周报告问题列表
  getReportFAQuestion(params) {
    return axios('/report/footballAssociation/question', {
      method: 'get',
      params,
    });
  },
  // 获取足协周报告问题列表
  getReportFAYear(params) {
    return axios('/report/footballAssociation/year', {
      method: 'get',
      params,
    });
  },
  // 足协周总结详情
  getReportFAList(params) {
    return axios('/report/footballAssociation/list', {
      method: 'get',
      params,
    });
  },
  //    足协评价
  addReportFASummary(data) {
    return axios('/report/footballAssociation/summary', {
      method: 'post',
      data,
    });
  },
  //   修改足协评价
  upReportFASummary(data) {
    return axios('/report/footballAssociation/summary', {
      method: 'PUT',
      data,
    });
  },
  // 获取足协报告
  getReportFA(params) {
    return axios('/report/footballAssociation', {
      method: 'get',
      params,
    });
  },
  //    添加足协周报告
  addReportFA(data) {
    return axios('/report/footballAssociation', {
      method: 'post',
      data,
    });
  },
  //    更新足协周报告
  upReportFA(data) {
    return axios('/report/footballAssociation', {
      method: 'put',
      data,
    });
  },
  // 删除足协周报告
  delReportFA(params) {
    return axios('/report/footballAssociation', {
      method: 'delete',
      params,
      paramsType: 'FormData',
    });
  },
  // ca =========================

  // CA列表
  courseCaList(params) {
    return axios(`${config.templateUrl}/course/ca/list`, {
      method: 'get',
      params,
    });
  },
  // 草稿/已完成列表
  courseList(params) {
    return axios(`${config.templateUrl}/course/list`, {
      method: 'get',
      params,
    });
  },

  // 添加课程
  addCourse(data) {
    return axios(`${config.templateUrl}/course`, {
      method: 'post',
      data,
    });
  },
  // 编辑课程详情
  updateCourse(data) {
    return axios(`${config.templateUrl}/course`, {
      method: 'put',
      data,
    });
  },

  // CA文章模板详情
  CATemplate(method, data) {
    if (method == 'get') {
      return axios(`${config.templateUrl}/course/details`, {
        method,
        params: data,
      });
    }
    return axios(`${config.templateUrl}/course/details`, {
      method,
      data,
    });
  },

  // 保存为草稿
  courseDraft(data) {
    return axios(`${config.templateUrl}/course/draft`, {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },

  // 已完稿
  doneCourse(data) {
    return axios(`${config.templateUrl}/course/finalized`, {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },

  // 获取课程详情
  getCourse(params) {
    return axios(`${config.templateUrl}/course`, {
      method: 'get',
      params,
    });
  },

  // 发布课程
  coursePublish(data) {
    return axios(`${config.templateUrl}/course/publish`, {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },

  // 下架课程/取消发布
  cancelPublish(data) {
    return axios(`${config.templateUrl}/course/publish`, {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },

  // 删除课程
  delCourse(data) {
    return axios(`${config.templateUrl}/course`, {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  // 模板导入
  importWorkItemApi(data) {
    return axios('/schedule/import/workItem', {
      method: 'post',
      data,
    });
  },

  // 添加章节片段
  addCourseContent(data) {
    return axios(`${config.templateUrl}/course/content`, {
      method: 'post',
      data,
    });
  },

  // 删除章节片段
  delCourseContent(data) {
    return axios(`${config.templateUrl}/course/content`, {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },

  // 更新章节片段
  updateCourseContent(data) {
    return axios(`${config.templateUrl}/course/content`, {
      method: 'put',
      data,
      handleLoadingBySelf: true,
    });
  },

  // 获取章节片段
  getCourseContent(params) {
    return axios(`${config.templateUrl}/course/content`, {
      method: 'get',
      params,
    });
  },

  // 保存导航
  saveCourseContent(data) {
    return axios(`${config.templateUrl}/course/content_list`, {
      method: 'post',
      data,
    });
  },
  // ca end =========================

  // 消息/公告列表    start

  // 获取列表
  getNewsList(params) {
    return axios('/news/list', {
      method: 'get',
      params,
    });
  },

  // 添加列表
  addNews(data) {
    return axios('/news', {
      method: 'post',
      data,
    });
  },

  // 更新列表
  putNews(data) {
    return axios('/news', {
      method: 'put',
      data,
    });
  },

  // 删除
  deleteNews(params) {
    return axios('/news', {
      method: 'delete',
      params,
    });
  },

  // 获取信息列表详情
  getNews(params) {
    return axios('/news', {
      method: 'get',
      params,
    });
  },
  // 消息/公告列表    end

  // 比赛报告列表 start
  getMatchReportList(params) {
    return axios('/match_report/list', {
      method: 'get',
      params,
    });
  },
  // 新建工单
  addWorkOrder(data) {
    return axios('/match_report/work_order', {
      method: 'post',
      data,
    });
  },
  // 获取比赛报告标签列表
  getLabelList(params) {
    return axios('/match_report/tag/list', {
      method: 'get',
      params,
    });
  },
  // 比赛报告列表 end

  // 设置比赛日状态
  setMatch_date(params, data) {
    return axios('/match_date', {
      method: 'put',
      params,
      data,
    });
  },

  // 比赛日数据分析报告
  getMatch_dateReport(params) {
    return axios('/gps/match_date/report', {
      method: 'get',
      params,
    });
  },

  // 比赛日日历
  getMatch_dateCalendar(params) {
    return axios('/match_date/calendar', {
      method: 'get',
      params,
    });
  },

  // 获取gps球员数据分析
  getGpsPlayerReport(params) {
    return axios('/gps/player/report', {
      method: 'get',
      params,
    });
  },
  // 体测报告 - 体侧列表
  getPhysicalTestList(params) {
    return axios('/list_physical_test', {
      //体测列表
      method: 'get',
      params,
    });
  },
  // 球员信息 体测报告 体测列表
  getUserPhysicalTestList(params) {
    return axios('/list_physical_test/user', {
      //体测列表
      method: 'get',
      params,
    });
  },
  // 球员信息 体测报告 体测下面的模板列表
  getUserPhysicalTestListTemplate(params) {
    return axios('/physical/item_data/statistics_user_physical_test', {
      //体测列表
      method: 'get',
      params,
    });
  },

  // 体测报告 - 新建体侧
  addPhysicalTest(data) {
    return axios('/physical_test', {
      method: 'post',
      data,
    });
  },
  // 体测报告 - 更新体侧
  updatePhysicalTest(data) {
    return axios('/physical_test', {
      method: 'put',
      data,
    });
  },
  // 体测报告 - 删除体侧
  delPhysicalTest(data) {
    return axios('/physical_test', {
      method: 'DELETE',
      data,
      paramsType: 'FormData',
    });
  },
  // 体测报告 - 获取体侧
  getPhysicalTest(params) {
    return axios('/physical_test', {
      method: 'get',
      params,
    });
  },
  // 体测报告 - 体侧 - 体侧项数据列表
  getPhysicalTestItem(params) {
    return axios('/physical/item_data/list', {
      method: 'get',
      params,
    });
  },
  // 体测报告 - 体侧 - 添加体侧项数据
  addPhysicalTestItem(data) {
    return axios('/physical/item_data', {
      method: 'post',
      data,
    });
  },
  // 体测报告 - 体侧 - 更新体侧项数据
  updatePhysicalTestItem(data) {
    return axios('/physical/item_data', {
      method: 'put',
      data,
    });
  },
  // 体测报告 - 体侧 - 更新体侧项数据
  delPhysicalTestItem(data) {
    return axios('/physical/item_data', {
      method: 'DELETE',
      data,
    });
  },
  // 体测报告 - 体侧 - 梯队下体侧数据集合
  getStatisticsByTeam(params) {
    return axios('/physical/item_data/statistics_team_list', {
      method: 'get',
      params,
    });
  },
  // 体测报告 - 体侧 - 个人的体侧数据集合
  getStatisticsByPlayer(params) {
    return axios('/physical/item_data/statistics_user_list', {
      method: 'get',
      params,
    });
  },
  // rpe比赛分析报告
  getRPEMatch_dateTeam(params) {
    return axios('/rpe/match_date/team', {
      method: 'get',
      params,
    });
  },
  // 获取小程序二维码
  getShareQrcode(params) {
    return axios('/third_party/qrcode', {
      method: 'get',
      params,
      handleTipsBySelf: true, // 当返回的code不等于200时，自己处理错误，不用全局提示。默认为false。
      handleLoadingBySelf: true, // 不用弹loading，静默请求，或者组件内处理loading。默认为false。
      responseType: 'arraybuffer',
    });
  },
  // 获取 ts 试训球员列表
  getTrialPlayerList(params) {
    return axios('/ts/trial/player_list', {
      method: 'get',
      params,
    });
  },
  // 获取 ts 可添加试训的 球员列表
  getTrialSelPlayerList(params) {
    return axios('/ts/trial/select_player_list', {
      method: 'get',
      params,
    });
  },
  // 获取 ts 试训统计
  getTrialAnalysis(params) {
    return axios('/ts/trial/analysis', {
      method: 'get',
      params,
    });
  },
  // ts 添加试训球员
  addTrialPlayer(data) {
    return axios('/ts/trial', {
      method: 'post',
      data,
    });
  },
  // ts 结束试训球员
  delTrialPlayer(data) {
    return axios('/ts/trial', {
      method: 'DELETE',
      data,
      paramsType: 'FormData',
    });
  },
  // 获取 ts 组队列表
  getFormTeamList(params) {
    return axios('/ts/form_team_list', {
      method: 'get',
      params,
    });
  },
  // 新增 ts 组队
  postFormTeam(data) {
    return axios('/ts/form_team', {
      method: 'post',
      data,
    });
  },
  // 修改 ts 组队
  putFormTeam(data) {
    return axios('/ts/form_team', {
      method: 'put',
      data,
    });
  },
  // 解散 ts 组队
  deleteFormTeam(data) {
    return axios('/ts/form_team', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  // 获取 ts 组队球员列表
  getFormTeamPlayers(params) {
    return axios('/ts/form_team_players', {
      method: 'get',
      params,
    });
  },
  // 添加 ts 组队队伍添加球员
  postFormTeamPlayer(data) {
    return axios('/ts/form_team_player', {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  // 组队队伍成队 ts
  putTeamUp(data) {
    return axios('/ts/team_up', {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },
  // 选拔至其它梯队 ts
  postFormTeamPlayerSelect(data) {
    return axios('/ts/form_team_player_select', {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  // ts 新增试训球员评分
  postPlayerGrade(data) {
    return axios('/ts/player/grade', {
      method: 'post',
      data,
    });
  },
  // ts 修改试训球员评分
  putPlayerGrade(data) {
    return axios('/ts/player/grade', {
      method: 'put',
      data,
    });
  },
  // ts 删除试训球员评分
  delPlayerGrade(data) {
    return axios('/ts/player/grade', {
      method: 'DELETE',
      data,
      paramsType: 'FormData',
    });
  },

  // ts 集训
  // ts 梯队内组队总列表
  getAssembleTrainingList(params) {
    return axios('/ts/assemble_training/list', {
      method: 'get',
      params,
    });
  },
  // ts 添加一条集训
  postAssembleTraining(data) {
    return axios('/ts/assemble_training', {
      method: 'post',
      data,
    });
  },
  // ts 修改集训
  putAssembleTraining(data) {
    return axios('/ts/assemble_training', {
      method: 'put',
      data,
      handleTipsBySelf: true, // 当返回的code不等于200时，自己处理错误，不用全局提示。默认为false。
    });
  },
  // ts 获取集训详情
  getAssembleTraining(params) {
    return axios('/ts/assemble_training', {
      method: 'get',
      params,
      handleTipsBySelf: true, // 当返回的code不等于200时，自己处理错误，不用全局提示。默认为false。
    });
  },
  // ts 删除当前集训
  deleteAssembleTraining(data) {
    return axios('/ts/assemble_training', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  // ts 获取球员的集训报告分数
  getAssembleTrainingReport(params) {
    return axios('/ts/assemble_training/report', {
      method: 'get',
      params,
    });
  },

  //  ts 管理列表
  // 获取ts管理球员列表
  getTsPlayerList(params) {
    return axios('/ts/player/list', {
      method: 'get',
      params,
    });
  },
  // 添加列表
  addTSPlayer(data) {
    return axios('/ts/player', {
      method: 'post',
      data,
    });
  },
  // 获取全剧配置  configName : entryName
  getGlobalConfig(params) {
    return axios('/global/config', {
      method: 'GET',
      params,
    });
  },
  // 添加列表
  tSPlayerDispose(data) {
    return axios('/ts/player/dispose', {
      method: 'post',
      data,
    });
  },
  // 添加列表
  getCountries() {
    return axios(
      'https://club-pub.oss-cn-beijing.aliyuncs.com/common/json/countries.json',
      {
        method: 'get',
        handleTipsBySelf: true,
      }
    );
  },
  // 训练营START===============================
  // 添加训练营
  campApi(data, method) {
    return axios('/teens_camp', {
      method: method,
      data:
        method === 'post' || method === 'put' || method === 'delete'
          ? data
          : '',
      params: method === 'get' ? data : '',
      paramsType: method === 'delete' ? 'FormData' : '',
    });
  },
  // 训练营列表
  campListApi(params) {
    return axios('/teens_camp/list', {
      method: 'get',
      params,
    });
  },
  // 开营 闭营
  campCloseApi(data) {
    return axios('/teens_camp/close', {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },

  // 模板计划导入
  campImportApi(data) {
    return axios('/teens_camp/import/tmp', {
      method: 'post',
      data,
    });
  },
  // 训练营 详情
  campDetailApi(data, method) {
    return axios('/teens_camp/detail', {
      method: method,
      data:
        method === 'patch' ||
        method === 'delete' ||
        method === 'put' ||
        method === 'post'
          ? data
          : '',
      params: method === 'get' ? data : '',
    });
  },
  // 训练营梯队 添加 修改
  campTeamApi(data, method) {
    return axios('/teens_camp_team', {
      method: method,
      data:
        method === 'patch' ||
        method === 'delete' ||
        method === 'post' ||
        method === 'put'
          ? data
          : '',
      params: method === 'get' ? data : '',
      paramsType: method === 'delete' ? 'FormData' : '',
    });
  },
  // 球员转出
  campTeamTransferApi(data) {
    return axios('/teens_camp_team/transfer', {
      method: 'put',
      data,
    });
  },
  // 球员操作
  campPlayerApi(data, method) {
    return axios('/teens_camp_team/player', {
      method: method,
      data:
        method === 'patch' ||
        method === 'delete' ||
        method === 'post' ||
        method === 'put'
          ? data
          : '',
      params: method === 'get' ? data : '',
      paramsType: method === 'delete' ? 'FormData' : '',
    });
  },
  // 训练营 选材组列表
  campSelectionsListApi(params) {
    return axios('/teens_camp/selection/list', {
      method: 'get',
      params,
    });
  },
  //  职员操作
  campStaffApi(data, method) {
    return axios('/teens_camp_team/staff', {
      method: method,
      data:
        method === 'patch' ||
        method === 'delete' ||
        method === 'post' ||
        method === 'put'
          ? data
          : '',
      params: method === 'get' ? data : '',
      paramsType: method === 'delete' ? 'FormData' : '',
    });
  },
  // 可添加的球员
  campPlayerNotInTeamApi(params) {
    return axios('/teens_camp/player_not_in_team', {
      method: 'get',
      params,
    });
  },
  // 可添加的教练员
  campStaffNotInTeamApi(params) {
    return axios('/teens_camp/staff_not_in_team', {
      method: 'get',
      params,
    });
  },
  // 转会 可添加的教练员
  teensCampStaffListApi(params) {
    return axios('/teens_camp/selection/staff/list', {
      method: 'get',
      params,
    });
  },
  // 添加球员||教练员
  campTeamUser(data, method) {
    return axios('/teens_camp_team/user', {
      method: method,
      data:
        method === 'patch' ||
        method === 'delete' ||
        method === 'post' ||
        method === 'put'
          ? data
          : '',
      params: method === 'get' ? data : '',
    });
  },
  // 用户所在的开营状态的青训营列表
  teensCampList(params) {
    return axios('/teens_camp/user_camp_list', {
      method: 'get',
      params,
    });
  },

  // 训练营球员伤病列表
  teensCampInjuryList(params) {
    return axios('/injury/camp_players', {
      method: 'get',
      params,
    });
  },

  // 训练营梯队人员最近伤病
  injuryCampRecently(params) {
    return axios('/injury/camp_recently', {
      method: 'get',
      params,
    });
  },

  // 训练营当日伤病报告
  teensCampInjuryReport(data) {
    return axios(`${config.eliteUrl}/injury/report/day_period`, {
      method: 'post',
      data,
    });
  },

  // 训练营球员视频分析
  teensCampPlayerVideo(params) {
    return axios('/teens_camp_team/player_video_analysis', {
      method: 'get',
      params,
    });
  },

  // 训练营体测球员个人列表
  teensCampUserPhysicalTestList(params) {
    return axios('/physical/user_camp_physicalTest_list', {
      method: 'get',
      params,
    });
  },

  // 开营通知
  openingNotification(data, method) {
    return axios('/opening_notification', {
      method: method,
      data:
        method === 'delete' || method === 'put' || method === 'post'
          ? data
          : '',
      params: method === 'get' ? data : '',
    });
  },

  // 开营球员列表
  openingNotificationPlayers(params) {
    return axios('/opening_notification/players', {
      method: 'get',
      params,
    });
  },
  // 开营教练员列表
  openingNotificationStaff(params) {
    return axios('/opening_notification/staffs', {
      method: 'get',
      params,
    });
  },

  // 开营通知工作安排
  openingNotificationSchedules(params) {
    return axios('/teens_camp/schedule', {
      method: 'get',
      params,
    });
  },

  // 训练营总结报告填写部分
  campFinalReport(data, method) {
    return axios('/final_report', {
      method: method,
      data:
        method === 'delete' || method === 'put' || method === 'post'
          ? data
          : '',
      params: method === 'get' ? data : '',
    });
  },

  // 训练营总结人员构成
  campFinalReportUsers(params) {
    return axios('/final_report/users', {
      method: 'get',
      params,
    });
  },

  // 训练营总结体测
  campFinalReportPhysicals(params) {
    return axios('/final_report/physicals', {
      method: 'get',
      params,
    });
  },

  // 训练营总结球员评估报告
  campFinalReportPlayerEvaluation(params) {
    return axios('/final_report/player_evaluation', {
      method: 'get',
      params,
    });
  },

  // 训练营总结职员评估
  campFinalReportStaffEvaluation(params) {
    return axios('/final_report/staff_evaluation', {
      method: 'get',
      params,
    });
  },

  // 训练营总结伤病报告
  campFinalReportInjury(params) {
    return axios('/final_report/injury_report', {
      method: 'get',
      params,
    });
  },

  // 训练营总结视频分析报告
  campFinalReportPlayerVideo(params) {
    return axios('/final_report/player_video_analysis', {
      method: 'get',
      params,
    });
  },

  // 训练营总结视频播放
  campFinalReportPlayerClips(params) {
    return axios('/final_report/player_clips', {
      method: 'get',
      params,
    });
  },

  // 训练营总结报告工作日志部分
  campFinalReportWorkLogs(params) {
    return axios('/final_report/work_logs', {
      method: 'get',
      params,
    });
  },

  // 工作日志列表
  getWorkLogs(params) {
    return axios('/work/logs', {
      method: 'get',
      params,
    });
  },

  // 工作列表
  getWorkList(params) {
    return axios('/work_log/list', {
      method: 'get',
      params,
    });
  },

  // 新增，修改，删除工作
  campWork(data, method) {
    return axios('/work_log', {
      method: method,
      data:
        method === 'delete' || method === 'put' || method === 'post'
          ? data
          : '',
      params: method === 'get' ? data : '',
      paramsType: method === 'delete' ? 'FormData' : '',
    });
  },

  // 添加视频
  addCampVideo(data) {
    return axios('/video/save', {
      method: 'post',
      data,
    });
  },

  //删除原视频
  deleteCampVideo(data) {
    return axios('/video', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },

  // 获取青训营视频详情
  getCampVideoDetail(params) {
    return axios('/video', {
      method: 'get',
      params,
    });
  },

  // 获取青训营周视图工作项
  getCampWorkItemList(params) {
    return axios('/schedule/camp_week', {
      method: 'get',
      params,
    });
  },
  // TOP榜单 - 分析
  teensCampClipListAnalysis(params) {
    return axios('/teens_camp/top', {
      method: 'get',
      params,
    });
  },
  // 获取体测榜单
  getPhysical_list_analysis(params) {
    return axios('/teens_camp/physical_list_analysis', {
      method: 'get',
      params,
    });
  },

  // 获取体测榜单
  getPhysical_templates(params) {
    return axios('/teens_camp/physical_templates', {
      method: 'get',
      params,
    });
  },
  // 训练营下所有球员列表(不分梯队)
  getTeensCampPlayers(params) {
    return axios('/teens_camp/players', {
      method: 'get',
      params,
    });
  },

  // 精英人才库列表
  getTeensCampElites(params) {
    return axios('/teens_camp/elites', {
      method: 'get',
      params,
    });
  },

  // 增加/修改/删除精英人才
  teensCampElite(params, data) {
    return axios('/teens_camp/elite', {
      method: 'post',
      params,
      data,
    });
  },

  // 获取人员动态表单信息
  getUser_form_data(params) {
    return axios('/user_form_data', {
      method: 'get',
      params,
    });
  },
  // 获取配置表单列表
  getUserFormList(params) {
    return axios('/userForm/list', {
      method: 'get',
      params,
    });
  },

  // 获取荣誉列表(优秀球员/最佳阵容)
  getTeensHonorList(params) {
    return axios('/honor/list', {
      method: 'get',
      params,
    });
  },

  // 新增/删除/修改荣誉
  teensCampHonor(data, method) {
    return axios('/honor', {
      method,
      params: method == ' get' ? data : '',
      data: method != 'get' ? data : '',
    });
  },

  // 新增/修改个人荣誉
  teensCampUserHonor(data) {
    return axios('/user_honor', {
      method: 'post',
      data,
    });
  },
  // 训练营报告 - 投票统计
  getVoteData(params) {
    return axios('/vote/analysis', {
      method: 'get',
      params,
    });
  },
  //  训练营报告 - 投票统计 类型
  getVoteType() {
    return axios('/vote/type', {
      method: 'get',
    });
  },
  // 训练营 END=================================

  // 公共版 VI 登录 / 获取视频列表 ====== start
  // 登录
  postViLogin(data) {
    return axios(`${config.viApiUrl}/login`, {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  // 获取视频列表
  getViVideoList(params) {
    let token = params.token;
    delete params.token;
    return axios(`${config.viApiUrl}/video/list`, {
      method: 'get',
      params,
      handleTipsBySelf: true,
      headers: {
        Authorization: token,
      },
    });
  },

  // 同步视频
  getVideoPull(params) {
    let token = params.token;
    delete params.token;
    return axios(`${config.viApiUrl}/video/pull`, {
      method: 'get',
      params,
      handleTipsBySelf: true,
      headers: {
        Authorization: token,
      },
    });
  },

  // 提交视频
  postViCloudPull(data, teamId) {
    return axios(`/video/vi_cloud_pull?teamId=${teamId}`, {
      method: 'post',
      data,
    });
  },
  // 选材组排序
  selectionOrder(params) {
    return axios('/teens_camp/selection/reorder', {
      method: 'put',
      params,
    });
  },
  // 教练员排序
  adminOrderStaff(params) {
    return axios('/teens_camp_team/user/reorder', {
      method: 'put',
      params,
    });
  },
  // 公共版 VI 登录 / 获取视频列表 ====== end
  // 选材组
  teensCampSelection(data, method) {
    return axios('/teens_camp/selection', {
      method: method,
      data:
        method === 'post' || method === 'put' || method === 'delete'
          ? data
          : '',
      params: method === 'get' ? data : '',
      paramsType: method === 'delete' ? 'FormData' : '',
    });
  },
  // admin===================START
  sendMsg(params) {
    //发送登录短信
    return axios('/sms/login', {
      method: 'get',
      params,
      handleTipsBySelf: true, // 自己处理返回值
      tenant: false,
    });
  },
  loginPhone(params) {
    //手机号登录
    return axios('/login_phone', {
      method: 'post',
      params,
      handleTipsBySelf: true,
      tenant: false,
    });
  },

  /**
   * @desc 现场评审指标列表
   * @returns
   */
  // 获取模板 type  1："实地考察"   2："现场评审"
  getTemplate(params) {
    return axios('/template', {
      method: 'get',
      params,
    });
  },
  // 列表
  getAssessmentList(params) {
    return axios('/report/detail/site/assessment/list', {
      method: 'get',
      params,
    });
  },
  // 评分列表
  getAssessment(params) {
    return axios('/report/detail/site/assessment', {
      method: 'get',
      params,
    });
  },
  // 新增
  getAssessmentAdd(data) {
    return axios('/report/detail/site_assessment', {
      method: 'post',
      data,
    });
  },
  // 编辑
  getAssessmentEdit(data) {
    return axios('/report/detail', {
      method: 'put',
      data,
    });
  },
  // 删除
  getAssessmentDelete(params) {
    return axios('/report/detail', {
      method: 'delete',
      params,
    });
  },
  // 调研报告列表
  reportList(params) {
    return axios('/report/list', {
      method: 'get',
      params,
    });
  },
  // 新建调研报告
  addReport(data) {
    return axios('/report', {
      method: 'post',
      data,
    });
  },
  // 更新调研报告
  updateReport(data) {
    return axios('/report', {
      method: 'put',
      data,
    });
  },
  // 删除调研报告
  delReport(params) {
    return axios('/report', {
      method: 'delete',
      params,
    });
  },
  // 发布调研报告
  publishReport(params) {
    return axios('/report/push', {
      method: 'put',
      params,
    });
  },
  // 获取现场评审明细列表
  getFieldList(params) {
    return axios('/report/detail/field/visit', {
      method: 'get',
      params,
    });
  },
  // 修改得分
  updateReportDetail(params, data) {
    return axios('/report/detail/field_visit', {
      method: 'put',
      params,
      data,
    });
  },
  // key=教案标签：tags；教案年龄：age；比赛阶段：stage；训练赛节数：section；
  // 比赛阵型：formation；比赛事件：matchevent；工作项类型：itemtype；
  // 职务：title；名单类别：listType；球员位置：position；综合评分：total
  // 球员来源：sourceType  女足年龄段：wheel 教练员职称列表：visual_title
  // 青训营视频标签：videoLable
  // 评估中英文：
  getCommonData(params, tenant) {
    //查询通用定义数据
    return axios('/common/data', {
      method: 'get',
      params,
      tenant: !tenant,
    });
  },
  /**
   * 俱乐部管理
   */
  // 职务列表
  getJobList(params) {
    return axios('/job/list', {
      method: 'get',
      params,
    });
  },
  // 人脸验证照片上传
  uploadFaceImg(data) {
    return axios('/common/uploadFace', {
      method: 'post',
      data,
    });
  },

  // 管理端所有城市列表
  adminCityList(params) {
    //通用上传文件
    return axios('/city/list', {
      method: 'get',
      params,
    });
  },
  // 管理端新增编辑职员
  adminAddUser(data, method) {
    return axios('/user', {
      method,
      data,
      tenant: true,
    });
  },
  // 管理端删除职员
  adminRemoveUser(data) {
    return axios('/user', {
      method: 'delete',
      data,
      paramsType: 'FormData',
      tenant: true,
    });
  },
  // 获取所有版本产品更新内容详情  /product_intro/list
  getAllproduct(params) {
    return axios('/product/intros', {
      method: 'get',
      params,
    });
  },
  // admin===================END
  // 获取青训营视频标签
  getVideoClipLabel() {
    return axios(`/teens_camp/videoClipLabel`, {
      method: 'get',
    });
  },

  // 获取球员事件矩阵数据 各项成功率(按人，矩阵)
  getCamp_player_successRate(params) {
    return axios(`/schedule/camp_player_successRate`, {
      method: 'get',
      params,
    });
  },

  // 获取事件成功率 各项成功率(所有的数据统计,不按人)
  getCamp_successRate(params) {
    return axios(`/schedule/camp_successRate`, {
      method: 'get',
      params,
    });
  },

  // 获取集团下俱乐部列表
  getClubList(params) {
    return axios(`/club/list`, {
      method: 'get',
      params,
    });
  },
  // 教练员考核分析
  getAssessAnalysis(params) {
    return axios(`/assess/analysis`, {
      method: 'get',
      params,
    });
  },
  // 考核列表
  getAssessList(params) {
    return axios('/assess/list', {
      method: 'get',
      params,
    });
  },
  // 查询评审标准列表
  getAssessStandard(params) {
    return axios(`/assess/standard/list`, {
      method: 'get',
      params,
    });
  },
  // 新增，修改评审标准
  editAssessStandard(data) {
    return axios('/assess/standard', {
      method: 'post',
      data,
    });
  },
  // 删除评审规则
  deleteAssessStandard(data) {
    return axios('/assess/standard', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  // 教练员个人评估分析详情
  getAssessAnalysisStaff(params) {
    return axios(`/assess/analysis/staff`, {
      method: 'get',
      params,
    });
  },

  // 新建考核
  addAssess(data) {
    return axios('/assess', {
      method: 'post',
      data,
    });
  },

  // 删除考核
  deleteAssess(data) {
    return axios('/assess', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },

  // 更新考核
  updateAssess(data) {
    return axios('/assess', {
      method: 'put',
      data,
    });
  },

  // 考核详情
  getAssessDetail(params) {
    return axios('/assess', {
      method: 'get',
      params,
    });
  },

  // 考核规则列表
  getAssessRuleList(params) {
    return axios('/assess/rule/list', {
      method: 'get',
      params,
    });
  },

  // 添加考核规则
  addAssessRule(data) {
    return axios('/assess/rule', {
      method: 'post',
      data,
    });
  },

  // 删除考核规则
  deleteAssessRule(data) {
    return axios('/assess/rule', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },

  // 更新考核规则
  updateAssessRule(data) {
    return axios('/assess/rule', {
      method: 'put',
      data,
    });
  },

  // 添加教练员（批量）
  addStaffs(data) {
    return axios('/assessee', {
      method: 'post',
      data,
    });
  },

  // 删除教练员
  deleteStaff(data) {
    return axios('/assessee', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },

  // 考核中的教练员
  assessStaffList(params) {
    return axios('/assess/staff/list', {
      method: 'get',
      params,
    });
  },

  // 变更考核状态
  changeAssessStatus(data) {
    return axios('/assess/status', {
      method: 'put',
      data,
      paramsType: 'FormData',
      handleTipsBySelf: true,
    });
  },

  // 集团列表
  getGroupList(params) {
    return axios('/Id/list', {
      method: 'get',
      params,
    });
  },

  // 俱乐部下的教练员列表
  getClubStaffList(params) {
    return axios('/staff/list', {
      method: 'get',
      params,
    });
  },

  // 集团是否正在考核中
  getAssessOpen(params) {
    return axios('/assess/open', {
      method: 'get',
      params,
    });
  },

  // 获取报告详情
  getAssessReport(params) {
    return axios('/assess/report', {
      method: 'get',
      params,
    });
  },

  // 添加报告
  addAssessReport(data) {
    return axios('/assess/report', {
      method: 'post',
      data,
    });
  },

  // 添加报告
  updateAssessReport(data) {
    return axios('/assess/report', {
      method: 'put',
      data,
    });
  },

  // 删除报告
  deleteAssessReport(data) {
    return axios('/assess/report', {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },
  //===============================模板Start
  // 训练营模板 添加编辑删除
  campTemApi(data, method) {
    return axios(`${config.templateUrl}/teens_camp_template`, {
      method: method,
      data:
        method === 'post' || method === 'put' || method === 'delete'
          ? data
          : '',
      params: method === 'get' ? data : '',
      paramsType: method === 'delete' ? 'FormData' : '',
      groupId: true,
    });
  },
  // 训练营模板 列表
  campTemPlanListApi(params) {
    return axios(`${config.templateUrl}/teens_camp_template/list`, {
      method: 'get',
      params,
      groupId: true,
    });
  },
  // 训练营模板 完稿
  templateFinalizedApi(params) {
    return axios(`${config.templateUrl}/teens_camp_template/finalized`, {
      method: 'put',
      params,
    });
  },
  // 训练营模板 保存草稿
  templateDraftApi(params) {
    return axios(`${config.templateUrl}/teens_camp_template/draft`, {
      method: 'put',
      params,
    });
  },
  // 训练营模板 内容
  campTemContentApi(data, method) {
    return axios(`${config.templateUrl}/teens_camp_template/content`, {
      method: method,
      data: method === 'patch' || method === 'delete' ? data : '',
      params: method === 'get' ? data : '',
      groupId: true,
    });
  },
  // 训练营模板 详情
  campTemDetailApi(data, method) {
    return axios(`${config.templateUrl}/teens_camp_template/detail`, {
      method: method,
      data: method === 'put' || method === 'post' ? data : '',
      params: method === 'get' ? data : '',
    });
  },
  // 训练营模板 创建新副本
  campTemCopyApi(data) {
    return axios(`${config.templateUrl}/teens_camp_template/copy`, {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  // 训练营模板 发布
  campTemplateReleaseApi(data) {
    return axios(`${config.templateUrl}/teens_camp_template/release`, {
      method: 'put',
      data,
    });
  },
  // 体测模板 列表
  getTemplateList(params) {
    return axios(`${config.templateUrl}/physical_template/list`, {
      method: 'get',
      params,
      groupId: true,
    });
  },
  // 体测模板 创建新副本
  physicalTemplateCopyApi(data) {
    return axios(`${config.templateUrl}/physical_template/copy`, {
      method: 'post',
      data,
      paramsType: 'FormData',
    });
  },
  // 体测模板 体测详情
  getPhysicalTemplateDetail(params) {
    return axios(`${config.templateUrl}/physical_template`, {
      method: 'get',
      params,
    });
  },
  // 体测模板 新建模板
  addTemplate(data) {
    return axios(`${config.templateUrl}/physical_template`, {
      method: 'post',
      data,
    });
  },
  // 体测模板 更新模板信息
  updateTemplate(data) {
    return axios(`${config.templateUrl}/physical_template`, {
      method: 'put',
      data,
    });
  },
  // 体测模板 删除模板信息
  delTemplate(data) {
    return axios(`${config.templateUrl}/physical_template`, {
      method: 'DELETE',
      data,
      paramsType: 'FormData',
    });
  },
  // 体测模板 体侧项 增删改
  templatePhysicalTest(data) {
    return axios(`${config.templateUrl}/physical_template/items`, {
      method: 'post',
      data,
    });
  },
  // 体测模板 完稿
  physicalTemplateFinalizedApi(params) {
    return axios(`${config.templateUrl}/physical_template/finalized`, {
      method: 'put',
      params,
    });
  },
  // 体测模板 保存草稿
  physicalTemplateDraftApi(params) {
    return axios(`${config.templateUrl}/physical_template/draft`, {
      method: 'put',
      params,
    });
  },
  // 训练营模板 发布
  physicalTemplateReleaseApi(data) {
    return axios(`${config.templateUrl}/physical_template/release`, {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },
  //===============================模板End

  // 赛事管理 --------- star
  getTournamentList(params) {
    return axios(`${config.tournamentUrl}/list`, {
      method: 'get',
      params,
    });
  },
  getTournamentTags(params) {
    return axios(`${config.tournamentUrl}/tags`, {
      method: 'get',
      params,
    });
  },
  addTournamentTags(data) {
    return axios(`${config.tournamentUrl}/tags`, {
      method: 'post',
      data,
    });
  },
  getTournamentInfo(params) {
    return axios(`${config.tournamentUrl}/`, {
      method: 'get',
      params,
    });
  },
  getTournamentStage(params) {
    return axios(`${config.tournamentUrl}/stage/list`, {
      method: 'get',
      params,
    });
  },
  tournamentMatch(data, method) {
    return axios(`${config.tournamentUrl}/match`, {
      method: method,
      data:
        method === 'post' || method === 'put' || method === 'delete'
          ? data
          : '',
      params: method === 'get' ? data : '',
      groupId: true,
    });
  },
  // 赛事授权
  tournamentEmpower(data, method) {
    return axios(`${config.tournamentUrl}/empower`, {
      method: method,
      data: method === 'post' ? data : '',
      params: method === 'get' ? data : '',
      groupId: true,
    });
  },
  // 已授权机构
  getTournamentEmpower(params) {
    return axios(`${config.tournamentUrl}/empower/tenants`, {
      params,
      groupId: true,
    });
  },
  /**
   * 比赛提交工单
   */
  tournamentMatchSubmit(data) {
    return axios(`${config.tournamentUrl}/match/report`, {
      method: 'post',
      data,
    });
  },
  /**
   * 删除某赛事某个阶段
   */
  delTournamentStage(data) {
    return axios(`${config.tournamentUrl}/stage`, {
      method: 'delete',
      data,
      paramsType: 'FormData',
    });
  },

  // 赛事管理 --------- end

  //队伍管理 --- star
  getMatchTeamList(params) {
    return axios(`/team/list`, {
      method: 'get',
      params,
    });
  },
  getMatchTeamDetail(params) {
    return axios(`/team`, {
      method: 'get',
      params,
    });
  },
  getFilterTags(params) {
    return axios(`/team/filter_tags`, {
      method: 'get',
      params,
    });
  },
  addMatchTeam(data, method) {
    return axios(`/team`, {
      method,
      data,
      paramsType: method === 'delete' ? 'FormData' : '',
    });
  },
  addMatchPlayer(data, method) {
    return axios(`/player`, {
      method,
      data,
      paramsType: method === 'delete' ? 'FormData' : '',
    });
  },

  //队伍管理 --- end

  // START 共享数据
  // 授权给我的列表
  getLicenseToMe(params) {
    return axios(`/license/to`, {
      method: 'get',
      params,
    });
  },
  // 我的授权列表
  getLicenseByMe(params) {
    return axios(`/license/by`, {
      method: 'get',
      params,
    });
  },
  // 获取授权数据
  getLicenseData(params) {
    return axios(`/license/data`, {
      method: 'get',
      params,
    });
  },
  // 获取授权码
  getLicenseCode(params) {
    return axios(`/license/code`, {
      method: 'get',
      params,
    });
  },
  // 使用授权码
  useLicenseCode(params) {
    return axios(`/license/bind`, {
      method: 'get',
      params,
    });
  },
  // 删除授权
  delLicense(params) {
    return axios(`/license`, {
      method: 'delete',
      params,
      paramsType: 'FormData',
    });
  },
  // 禁用
  disabledLicense(data) {
    return axios(`/license/enable`, {
      method: 'put',
      data,
      paramsType: 'FormData',
    });
  },
  // 操作日志
  getLicenseLogs(params) {
    return axios(`/license/logs`, {
      method: 'get',
      params,
    });
  },
  // 操作日志的人
  getLogsUser(params) {
    return axios(`/license/log_users`, {
      method: 'get',
      params,
    });
  },
  // 新建授权数据 /license
  addLicenseData(data) {
    return axios(`/license`, {
      method: 'post',
      data,
    });
  },
  // 新建授权数据 -  机构下球员数据 /tenant/player
  getTenantPlayer(params) {
    return axios(`/tenant/player`, {
      method: 'get',
      params,
    });
  },
  // 推送数据
  sendTenantPlayer(params, data) {
    return axios(`/license/recommend`, {
      method: 'post',
      params,
      data,
    });
  },
  // End 共享数据
  // 获取比赛报告Url地址
  workOrderApi(params) {
    return axios(`${config.tournamentReportUrl}/work_order`, {
      method: 'get',
      params,
      paramsToken: 'custom-token',
    });
  },
  // 训练营总结人员构成
  campDynamicUsers(data) {
    return axios(`${config.clubhubUrl}/users`, {
      method: 'post',
      data,
    });
  },
  // 获取人员header
  getFieldsScene(data) {
    return axios(`${config.clubhubUrl}/user/field_config/scene`, {
      method: 'post',
      data,
    });
  },
  // 系统维护
  maintenanceDetail(params) {
    return axios(`${config.CMSAPI}/cms/maintenance/detail`, {
      method: 'get',
      params,
      paramsToken: 'custom-token',
    });
  },
};

Object.assign(
  server,
  clubhub,
  elite,
  injury,
  staige,
  player,
  trainingCamp,
  training,
  scoutReport
);
export default server;
